
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import StageUpdateModal from '@/app/components/FieldDetails/StageUpdateModal.vue'
import GraphDialog from '@/app/components/FieldDetails/GraphDialog.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { harvestStatus, userType } from '@/app/model/store/domain/const'
/* pulugin */
import * as ChartAnnotation from 'chartjs-plugin-annotation'
import * as ChartDraggable from 'chartjs-plugin-draggable'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'
/* api */
import GetLinkImgApi from '@/app/model/api/getLinkImgApi'
import GetNewsBoardFileApi from '@/app/model/api/getNewsBoardFileApi'
import newsBoardContentsListApi from '@/app/model/api/newsBoardContentsListApi'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'
import ExternalLinkContentsListApi from '@/app/model/api/externalLinkContentsListApi'

@Component({
  components: {
    Graph: () => import('@/app/components/FieldDetails/Graph.vue'),
    StageUpdateModal,
    GraphDialog,
    ConfirmModal,
    DatePicker
  }
})
export default class FieldGraph extends Vue {
  private isActive: boolean = false
  private label: any[] = []
  private todayValue: any = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))
  private showStageUpdateModal: boolean = false
  private showDetailsDialog: boolean = false
  private showAreaChart: boolean = true
  private showTemparatureChart: boolean = false
  private showGrowthHightChart: boolean = false
  private showNdviChart: boolean = false
  private showSolarRadationChart: boolean = false
  private showTemperatureChart: boolean = false
  private showDviModalBtn: boolean = false
  private showMidDrainageModalBtn: boolean = false
  private stageDate: string = ''
  private growthData: {[key: string]: string|number|any} = {}
  private dialogTop: string = '0px'
  private dialogLeft: string = '0px'
  private graphMaxDay: any = ''
  private slideWidth: number = 0
  private slideTop: number = 35
  private slideRangeLineTop: number = 20
  private slide: number = 0
  private subSlideWidth: number = 0
  private subSlideMargin: number = 0
  public chartData: any = {}
  public areaChartData: any = {}
  public growthHightChartData: any = {}
  public ndviChartData: any = {}
  public solarRadationChartData: any = {}
  public temperatureChartData: any = {}
  public temperatureDifferenceChartData: any = {}
  public predictionChartData: any = {}
  private checkboxData: {[key: string]: string|boolean}[] = []
  private imageRecordsData: any[] = []
  private imageData: any[] = []
  private pointIconsData: any[] = []
  private pointIconData: any[] = []
  private isPlantingIcon: boolean = true
  private showPlantingLink: boolean = false
  private cameraIcon: any = require('@/assets/icon/camera_icon.svg')
  private sicknessIcon: any = require('@/assets/icon/ico_sick_select@2x.png')
  private weedsIcon: any = require('@/assets/icon/ico_weed_select@2x.png')
  private pestIcon: any = require('@/assets/icon/ico_pest_select@2x.png')
  private highTemperatureIcon: any = require('@/assets/icon/ico_temperature_select@2x.png')
  private lodgingIcon: any = require('@/assets/icon/ico_lodging_select@2x.png')
  private otherRiskIcon: any = require('@/assets/icon/ico_condition_select@2x.png')
  private riskRecordsData: any[] = []
  private riskData: any = []
  private riskDetailData: any[] = []
  private showRiskDialogFlag: boolean = false
  private hoverIndex: number = 0
  private harvestStatus: number = 0
  private harvestStatusName: string= ''
  private harvestStatusUpdateData: any|null = ''
  private harvestStatusPosition: number = 0
  private showHarvestStatus: boolean = false
  private showConfirmModal: boolean = false
  private showStageDate: boolean = true
  private isInit: boolean = true
  private confirmMessage: string = '<p>アグリノート・FW2を同時に開くとメモリを消費して<br>端末の動作が不安定になることがありますが、開きますか？</p>'
  private fieldId = ''
  private plantingId = ''
  private userType = parseInt(Local.getUserType()!)
  private newsBoardTitle: string = ''
  private constantValue: any
  private externalLinkTitle: string = ''
  private transparentColor: string = 'rgba(0,0,0,0)'
  private isMidDrain: boolean = false
  private midDraingageBtnRight: number = 0
  private graphRange: any = [null, null]
  private initSliderDate: boolean = false
  public displayWaterData: any = {}
  public chartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      const type = Session.getStemNumberType()!
      var text = []
      text.push('<ul class="' + chart.id + '-legend">')
      // 配列の順番設定用
      const legendSort = ['実績積算温度(℃)', '比較積算温度(℃)', '指標積算温度(℃)', '予測積算温度(℃)', '実績茎数(本/株)', '比較茎数(本/株)', '指標茎数(本/株)', '実績茎数(本/平米)', '比較茎数(本/平米)', '指標茎数(本/平米)', '実績-画像解析-茎数(本/株)', '比較-画像解析-茎数(本/株)', '実績葉色値', '比較葉色値', '指標葉色値', '実績-画像解析-葉色', '比較-画像解析-葉色', '実績草丈(cm)', '比較草丈(cm)', '指標草丈(cm)', '実績-画像解析-草丈(cm)', '比較-画像解析-草丈(cm)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      for (var i = 0; i < items.length; i++) {
        if ((type === '1' && items[i].text === '実績茎数(本/平米)') ||
            (type === '1' && items[i].text === '比較茎数(本/平米)') ||
            (type === '1' && items[i].text === '指標茎数(本/平米)') ||
            (type === '2' && items[i].text === '実績茎数(本/株)') ||
            (type === '2' && items[i].text === '比較茎数(本/株)') ||
            (type === '2' && items[i].text === '指標茎数(本/株)')) {
          text.push('<li class="hide"><span class="legend-color"></span><span></span></li>')
          if (items[i].text === '指標茎数(本/平米)' ||
              items[i].text === '指標茎数(本/株)') {
            text.push('<br class="hide">')
          }
        // 画像解析は凡例1つで3つのグラフを表示切替するため凡例の表示数を調整
        } else if (i === 11 ||
                   i === 12 ||
                   i === 14 ||
                   i === 15 ||
                   i === 20 ||
                   i === 21 ||
                   i === 23 ||
                   i === 24 ||
                   i === 29 ||
                   i === 30 ||
                   i === 32 ||
                   i === 33) {
          text.push('<li class="hide"><span class="legend-color"></span><span></span></li>')
        } else if (!this.showCanonData &&
                  (items[i].text.startsWith('実績-画像解析-') || items[i].text.startsWith('比較-画像解析-'))) {
          text.push('<li class="hide"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>' + items[i].text + '</span></li>')
          if (items[i].text === '比較-画像解析-茎数(本/株)' ||
              items[i].text === '比較-画像解析-葉色') {
            text.push('<br class="hide">')
          }
        } else {
          // 凡例作成
          text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>' + items[i].text + '</span></li>')
          // 改行を追加
          if (items[i].text === '予測積算温度(℃)' ||
              items[i].text === '指標茎数(本/株)' ||
              items[i].text === '指標茎数(本/平米)' ||
              items[i].text === '指標葉色値' ||
              items[i].text === '指標草丈(cm)') {
            text.push('<br>')
          }
        }
      }
      text.push('</ul>')

      return 0 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: this.rangeLabel('right')
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 4000,
            stepSize: 1000
          },
          position: 'right'
        },
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            labelString: this.rangeLabel('left')
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50
          },
          position: 'left'
        }
      ]
    },
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date: any
          let displayDate: any

          // 比較草丈の場合
          if (tooltipItem[0].datasetIndex === 11) {
            /* 播種日同士の差分を求める */
            let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
            let comparisonPlant = DateClass.formingDate(Object.keys(JSON.parse(Session.getComparisonData()!))[0])
            let diff = plantingDay.getTime() - comparisonPlant.getTime()
            diff = Math.floor(diff / (1000 * 60 * 60 * 24))

            date = new Date(tooltipItem[0].xLabel)
            date.setDate(date.getDate() - diff)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          } else {
            date = new Date(tooltipItem[0].xLabel)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          }

          let today = new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + (new Date().getDate() - 1) + '日'
          if (displayDate === today) {
            displayDate += '(最新データ)'
          }

          return displayDate
        }
      }
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    annotation: {
      events: ['click', 'drag', 'mouseover'],
      annotations: []
    }
  }
  public areaChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績水位(cm)', '比較水位(cm)', '指標水位(cm)', '実績水温(℃)', '比較水温(℃)', '指標水温(℃)', '実績地温(℃)', '比較地温(℃)', '指標地温(℃)', '実績pH', '比較pH', '指標pH']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="2-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      // 改行を追加
      text.push('</ul>')

      return 1 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '水位・水温・地温・pH'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 10,
            maxTicksLimit: 4
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: '茎数・草丈・葉色値'
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            min: 0,
            max: 2000,
            stepSize: 50
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public precipitationChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="3-legend">')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(chart.legend.legendItems[i].text)
        text.push('</span></li>')

        if (i === 2 || i === 5 || i === 8 || i === 11) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 2 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 12,
        bottom: 20,
        right: 30
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算降水量(mm)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 4
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: '草丈・葉色値'
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            min: 0,
            max: 200,
            stepSize: 50
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public growthHightChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績草丈(cm)', '比較草丈(cm)', '実績桿長(cm)', '比較桿長(cm)', '実績穂長(cm)', '比較穂長(cm)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="5-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
        if (i === 1 || i === 3) {
          text.push('</br>')
        }
      }
      // 改行を追加
      text.push('</ul>')

      return 5 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '草丈・桿長・穂長'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 100,
            stepSize: 50
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          stacked: true,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: this.rangeLabel('right')
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            fontColor: '#fff',
            min: 0,
            max: 4000,
            stepSize: 1000
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public ndviChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績NDVI', '比較NDVI']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="8-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
      }
      // 改行を追加
      text.push('</ul>')

      return 7 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 35,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: 'NDVI'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            suggestedMax: 2,
            stepSize: 1
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          stacked: true,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: this.rangeLabel('right')
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            fontColor: '#fff',
            min: 0,
            max: 4000,
            stepSize: 1000
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public solarRadationChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績日射量(MJ/m2)', '比較日射量(MJ/m2)', '予測日射量(MJ/m2)', '実績積算日射量(MJ/m2)', '比較積算日射量(MJ/m2)', '予測積算日射量(MJ/m2)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="5-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
        if (i === 2) {
          text.push('</br>')
        }
      }
      // 改行を追加
      text.push('</ul>')

      return 4 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '日射量'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            maxTicksLimit: 3,
            suggestedMax: 40
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算日射量'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public temperatureChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      // 配列の順番設定用
      const legendSort = ['実績日平均気温(℃)', '比較日平均気温(℃)', '実績最高気温(℃)', '比較最高気温(℃)', '実績最低気温(℃)', '比較最低気温(℃)', '実績寒暖差(℃)', '比較寒暖差(℃)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))
      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      var text = []
      text.push('<ul class="7-legend">')
      for (var i = 0; i < items.length; i++) {
        // 凡例作成
        text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
        // 凡例名
        text.push(items[i].text)
        text.push('</span></li>')
        if (i === 1 || i === 3 || i === 5) {
          text.push('</br>')
        }
      }
      // 改行を追加
      text.push('</ul>')

      return 6 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 28,
        bottom: 10,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '気温'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 40,
            suggestedMin: -10,
            maxTicksLimit: 6
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: ''
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }
  public temperatureDifferenceChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 0,
        left: 28,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '寒暖差'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            suggestedMax: 40,
            suggestedMin: 0,
            maxTicksLimit: 5
          },
          position: 'left'
        },
        // データ的には不要だが領域を合わせるために必要
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            fontColor: '#fff',
            labelString: ''
          },
          ticks: {
            autoSkip: true,
            fontColor: '#fff',
            fontSize: 14,
            suggestedMax: 1000,
            maxTicksLimit: 3
          },
          position: 'right'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }

  @Prop() private plantingLinkData!: any
  private linkIcon: string = ''

  private async getLinkIcon () {
    const result = await GetLinkImgApi.getLinkImgData()
    this.linkIcon = String(result)
  }

  // 日付title表示用
  private displayDate (date: number, text: string) {
    const year = String(date).slice(0, 4)
    const month = String(date).slice(4, 6)
    const day = String(date).slice(6)

    if (text !== '') {
      return year + '年' + month + '月' + day + '日' + text
    }
    return year + '年' + month + '月' + day + '日'
  }

  private mouseOverRiskAction (index: number, details: any[]) {
    this.showRiskDialogFlag = true
    this.hoverIndex = index
    this.riskDetailData = details
    this.showDetailsDialog = false
  }
  private mouseLeaveRiskAction (index: number) {
    this.showRiskDialogFlag = false
  }

  private showNewsBoardDialogFlag = false
  private newsBoardDetailData: any[] = []
  private newsBoardHoverIndex: number = 0

  private showExternalLinkDialogFlag = false
  private externalLinkDetailData: any[] = []
  private externalLinkHoverIndex: number = 0

  private mouseOverNewsBoardAction (index: number, details: any[]) {
    this.showNewsBoardDialogFlag = true
    this.newsBoardDetailData = details
    this.newsBoardHoverIndex = index
    this.showDetailsDialog = false
  }
  private mouseLeaveNewsBoardAction () {
    this.showNewsBoardDialogFlag = false
  }

  private mouseOverExternalLinkAction (index: number, details: any[]) {
    this.showExternalLinkDialogFlag = true
    this.externalLinkDetailData = details
    this.externalLinkHoverIndex = index
    this.showDetailsDialog = false
  }
  private mouseLeaveExternalLinkAction () {
    this.showExternalLinkDialogFlag = false
  }

  // 表示設定からの表示非表示切り替え
  private displayIcon (index: number) {
    const ul: any = this.$refs.settingIconList
    const cameraIcons: any = this.$refs.cameraIconList
    const pointIcons: any = this.$refs.pointIconList
    const riskIcons: any = this.$refs.riskIconList
    const harvestStatusIcons: any = this.$refs.harvestStatusIcon
    const newsBoardIcons: any = this.$refs.newsBoardIconList
    const externalLinkIcons: any = this.$refs.externalLinkIconList
    // 撮影画像
    if (index === 1 && ul.children[0].classList.contains('hidden')) {
      ul.children[0].classList.remove('hidden')
      if (cameraIcons !== null && cameraIcons !== undefined) {
        for (let i = 0; i < cameraIcons.length; i++) {
          cameraIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 1) {
      ul.children[0].classList.add('hidden')
      if (cameraIcons !== null && cameraIcons !== undefined) {
        for (let i = 0; i < cameraIcons.length; i++) {
          cameraIcons[i].classList.add('hidden')
        }
      }
    }
    // 任意アイコン
    if (index === 2 && ul.children[1].classList.contains('hidden')) {
      ul.children[1].classList.remove('hidden')
      if (pointIcons !== null && pointIcons !== undefined) {
        for (let i = 0; i < pointIcons.length; i++) {
          pointIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 2) {
      ul.children[1].classList.add('hidden')
      if (pointIcons !== null && pointIcons !== undefined) {
        for (let i = 0; i < pointIcons.length; i++) {
          pointIcons[i].classList.add('hidden')
        }
      }
    }
    // 収穫リスク
    if (index === 3 && ul.children[2].classList.contains('hidden')) {
      ul.children[2].classList.remove('hidden')
      if (riskIcons !== null && riskIcons !== undefined) {
        for (let i = 0; i < riskIcons.length; i++) {
          riskIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 3) {
      ul.children[2].classList.add('hidden')
      if (riskIcons !== null && riskIcons !== undefined) {
        for (let i = 0; i < riskIcons.length; i++) {
          riskIcons[i].classList.add('hidden')
        }
      }
    }
    // 収穫ステータス
    if (index === 4 && ul.children[5].classList.contains('hidden')) {
      ul.children[5].classList.remove('hidden')
      harvestStatusIcons.classList.remove('hidden')
    } else if (index === 4) {
      ul.children[5].classList.add('hidden')
      harvestStatusIcons.classList.add('hidden')
    }
    // 栽培かわらばん
    if (index === 5 && ul.children[3].classList.contains('hidden')) {
      ul.children[3].classList.remove('hidden')
      if (newsBoardIcons !== null && newsBoardIcons !== undefined) {
        for (let i = 0; i < newsBoardIcons.length; i++) {
          newsBoardIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 5) {
      ul.children[3].classList.add('hidden')
      if (newsBoardIcons !== null && newsBoardIcons !== undefined) {
        for (let i = 0; i < newsBoardIcons.length; i++) {
          newsBoardIcons[i].classList.add('hidden')
        }
      }
    }
    // 生育ステージ日
    if (index === 6 && ul.children[6].classList.contains('hidden')) {
      ul.children[6].classList.remove('hidden')
      this.showStageDate = true
      for (let i in this.chartOptions.annotation.annotations) {
        if (i === '2' || i === '5' || i === '8' || i === '11' || i === '14' || i === '17' || i === '20' || i === '23' || i === '26' || i === '29') {
          this.chartOptions.annotation.annotations[i].label.backgroundColor = this.chartOptions.annotation.annotations[parseInt(i) - 1].label.backgroundColor
          this.chartOptions.annotation.annotations[i].label.fontColor = this.chartOptions.annotation.annotations[parseInt(i) - 1].label.fontColor
        }
      }
    } else if (index === 6) {
      ul.children[6].classList.add('hidden')
      this.showStageDate = false
      for (let i in this.chartOptions.annotation.annotations) {
        if (i === '2' || i === '5' || i === '8' || i === '11' || i === '14' || i === '17' || i === '20' || i === '23' || i === '26' || i === '29') {
          this.chartOptions.annotation.annotations[i].label.backgroundColor = this.transparentColor
          this.chartOptions.annotation.annotations[i].label.fontColor = this.transparentColor
        }
      }
    }
    // 外部連携機能
    if (index === 7 && ul.children[4].classList.contains('hidden')) {
      ul.children[4].classList.remove('hidden')
      if (externalLinkIcons !== null && externalLinkIcons !== undefined) {
        for (let i = 0; i < externalLinkIcons.length; i++) {
          externalLinkIcons[i].classList.remove('hidden')
        }
      }
    } else if (index === 7) {
      ul.children[4].classList.add('hidden')
      if (externalLinkIcons !== null && externalLinkIcons !== undefined) {
        for (let i = 0; i < externalLinkIcons.length; i++) {
          externalLinkIcons[i].classList.add('hidden')
        }
      }
    }
    const graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  private get openGraphSettingFlag (): boolean {
    return this.$store.state.setFlagState.openSettingModalFlag
  }
  @Watch('openGraphSettingFlag')
  getGraphCheckbox (flag: boolean) {
    if (flag) {
      // チェックボックス情報
      const data = [
        {
          label: '積算温度',
          value: 'integrationTemperature',
          checked: this.checkHidden([
            this.chartData.datasets[0].hidden,
            this.chartData.datasets[1].hidden,
            this.chartData.datasets[2].hidden,
            this.chartData.datasets[3].hidden
          ], true)
        },
        {
          label: '茎数(株)',
          value: 'stemNumber',
          checked: this.checkHidden([
            this.chartData.datasets[4].hidden,
            this.chartData.datasets[5].hidden,
            this.chartData.datasets[6].hidden
          ], true)
        },
        {
          label: '茎数(平米)',
          value: 'stemNumberM2',
          checked: this.checkHidden([
            this.chartData.datasets[7].hidden,
            this.chartData.datasets[8].hidden,
            this.chartData.datasets[9].hidden
          ], true)
        },
        {
          label: '草丈',
          value: 'growthHeight',
          checked: this.checkHidden([
            this.chartData.datasets[25].hidden,
            this.chartData.datasets[26].hidden,
            this.chartData.datasets[27].hidden
          ], true)
        },
        {
          label: '葉色値',
          value: 'spad',
          checked: this.checkHidden([
            this.chartData.datasets[16].hidden,
            this.chartData.datasets[17].hidden,
            this.chartData.datasets[18].hidden
          ], true)
        },
        {
          label: '画像解析-茎数(株)',
          value: 'imageAnalysisStemNumber',
          checked: this.checkHidden([
            this.chartData.datasets[10].hidden,
            this.chartData.datasets[11].hidden,
            this.chartData.datasets[12].hidden,
            this.chartData.datasets[13].hidden,
            this.chartData.datasets[14].hidden,
            this.chartData.datasets[15].hidden
          ], true)
        },
        {
          label: '画像解析-葉色',
          value: 'imageAnalysisSpad',
          checked: this.checkHidden([
            this.chartData.datasets[19].hidden,
            this.chartData.datasets[20].hidden,
            this.chartData.datasets[21].hidden,
            this.chartData.datasets[22].hidden,
            this.chartData.datasets[23].hidden,
            this.chartData.datasets[24].hidden
          ], true)
        },
        {
          label: '画像解析-草丈',
          value: 'imageAnalysisGrowthHeight',
          checked: this.checkHidden([
            this.chartData.datasets[28].hidden,
            this.chartData.datasets[29].hidden,
            this.chartData.datasets[30].hidden,
            this.chartData.datasets[31].hidden,
            this.chartData.datasets[32].hidden,
            this.chartData.datasets[33].hidden
          ], true)
        },
        {
          label: '桿長',
          value: 'stemLength',
          checked: this.checkHidden([
            this.growthHightChartData.datasets[2].hidden,
            this.growthHightChartData.datasets[3].hidden
          ], this.showGrowthHightChart)
        },
        {
          label: '穂長',
          value: 'earLength',
          checked: this.checkHidden([
            this.growthHightChartData.datasets[4].hidden,
            this.growthHightChartData.datasets[5].hidden
          ], this.showGrowthHightChart)
        },
        {
          label: '日射量',
          value: 'solarRadation',
          checked: this.checkHidden([
            this.solarRadationChartData.datasets[0].hidden,
            this.solarRadationChartData.datasets[1].hidden,
            this.solarRadationChartData.datasets[2].hidden
          ], this.showSolarRadationChart)
        },
        {
          label: '積算日射量',
          value: 'integratedInsolation',
          checked: this.checkHidden([
            this.solarRadationChartData.datasets[3].hidden,
            this.solarRadationChartData.datasets[4].hidden,
            this.solarRadationChartData.datasets[5].hidden
          ], this.showSolarRadationChart)
        },
        {
          label: '日平均気温',
          value: 'temperature',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[0].hidden,
            this.temperatureChartData.datasets[1].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '最高気温',
          value: 'temperatureHighest',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[2].hidden,
            this.temperatureChartData.datasets[3].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '最低気温',
          value: 'temperatureLowest',
          checked: this.checkHidden([
            this.temperatureChartData.datasets[4].hidden,
            this.temperatureChartData.datasets[5].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '寒暖差',
          value: 'temperatureDifference',
          checked: this.checkHidden([
            this.temperatureDifferenceChartData.datasets[0].hidden,
            this.temperatureDifferenceChartData.datasets[1].hidden
          ], this.showTemperatureChart)
        },
        {
          label: '積算降水量',
          value: 'soilStatus',
          checked: this.checkHidden([
            this.predictionChartData.datasets[0].hidden,
            this.predictionChartData.datasets[1].hidden,
            this.predictionChartData.datasets[2].hidden
          ], this.showTemparatureChart)
        },
        {
          label: '水位',
          value: 'waterLevel',
          checked: this.checkHidden([
            this.areaChartData.datasets[0].hidden,
            this.areaChartData.datasets[1].hidden,
            this.areaChartData.datasets[2].hidden
          ], this.showAreaChart)
        },
        {
          label: '水温',
          value: 'waterTemp',
          checked: this.checkHidden([
            this.areaChartData.datasets[3].hidden,
            this.areaChartData.datasets[4].hidden,
            this.areaChartData.datasets[5].hidden
          ], this.showAreaChart)
        },
        {
          label: '地温',
          value: 'groundTemp',
          checked: this.checkHidden([
            this.areaChartData.datasets[6].hidden,
            this.areaChartData.datasets[7].hidden,
            this.areaChartData.datasets[8].hidden
          ], this.showAreaChart)
        },
        {
          label: 'pH',
          value: 'ph',
          checked: this.checkHidden([
            this.areaChartData.datasets[9].hidden,
            this.areaChartData.datasets[10].hidden,
            this.areaChartData.datasets[11].hidden
          ], this.showAreaChart)
        },
        {
          label: 'NDVI',
          value: 'leafAge',
          checked: this.checkHidden([
            this.ndviChartData.datasets[0].hidden,
            this.ndviChartData.datasets[1].hidden
          ], this.showNdviChart)
        }
      ]
      this.$store.commit('graphState/setGraphCheckbox', data)
    }
  }

  private get getGlobalData (): any {
    return this.$store.state.setFlagState.growthDialogFlag
  }
  @Watch('getGlobalData')
  updateDialog (flag: boolean) {
    if (flag) {
      this.showGraphDialog()
      // flagリセット
      this.$store.commit('setFlagState/setGrowthDialogFlag', false)
    }
  }

  private get toggleComparison (): any {
    return this.$store.state.graphToggleState.hiddenComparisonData
  }
  @Watch('toggleComparison')
  hiddenToggleGraph (flag: boolean) {
    if (flag) {
      this.displayGraph()
    }
  }

  private get comparisonPlant (): any {
    return this.$store.state.setFlagState.comparisonPlantFlag
  }
  private get comparisonMaster (): any {
    return this.$store.state.setFlagState.comparisonMasterFlag
  }
  @Watch('comparisonPlant')
  updateComparison (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonMasterFlag) {
      if (!this.isInit) {
        this.updateDisplayYear()
      }
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
    }
  }
  @Watch('comparisonMaster')
  updateComparison2 (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonPlantFlag) {
      if (!this.isInit) {
        this.updateDisplayYear()
      }
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
    }
  }

  private get forceDateChangeFlag (): boolean {
    return this.$store.state.dateChoiceState.forceChangeDateFlag
  }
  // スライドバーの更新
  private get fieldDeatilsState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  @Watch('forceDateChangeFlag')
  onForceDateChangeed (flag: boolean) {
    if (!flag) {
      return
    }
    this.onChangeKeydate(this.$store.state.dateChoiceState.changeDate)
  }
  @Watch('fieldDeatilsState')
  onChangeKeydate (newVal: string) {
    if (this.label.length !== 0) {
      const fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
      const date = DateClass.daysCalculation(parseInt(fiestDay), parseInt(newVal))

      this.slide = date
    }
  }

  @Watch('plantingLinkData')
  getPlantingLinkData () {
    this.changePlantingLink()
  }

  private changePlantingLink () {
    if (this.plantingLinkData.planting_link === undefined || this.plantingLinkData.planting_link === null || this.plantingLinkData.planting_link === '') {
      this.showPlantingLink = false
    } else {
      this.showPlantingLink = true
    }

    if (this.plantingLinkData.planting_link_icon === null) {
      this.isPlantingIcon = false
    } else {
      this.getLinkIcon()
    }
  }

  private changeImageModal (date: any) {
    this.$store.commit('fieldDetailsState/setImgDate', date.record_date)
    this.$store.commit('setFlagState/setImgFlag', true)
  }

  private get masterDataFlag (): boolean {
    return this.$store.state.setFlagState.graphMasterDataFlag
  }

  private get dviBtnState (): boolean {
    return this.showDviModalBtn
  }
  @Watch('dviBtnState')
  setMidDrainageBtnRight () {
    this.midDraingageBtnRight = 235 + (this.showDviModalBtn ? 120 : 0)
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.fieldId = this.$route.params.field_id
    this.chartData = {}
    this.areaChartData = {}
    this.predictionChartData = {}
    this.createChartData()
    this.createAreaChartData()
    this.createPrecipitationChart()
    this.createGrowthHightChart()
    this.createNdviChart()
    this.createSolarRadationChart()
    this.createTemperatureChart()
    this.createTemperatureDifferenceChart()
    let growthStageList = JSON.parse(Session.getGrowthStage()!)
    this.createStageBar(growthStageList)
    this.changePlantingLink()
    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name

    // スライドバーの初期位置
    let graphData: any = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    if (this.label.length !== 0) {
      const fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
      const keyDate = DateClass.daysCalculation(fiestDay, lastDay)
      this.slide = keyDate
    }

    var userAgent = window.navigator.userAgent.toLowerCase()
    // firefoxのみ開始位置が中心のためtopを変更
    if (userAgent.indexOf('firefox') !== -1) {
      this.slideTop = 264
      this.slideRangeLineTop = 74
    }
  }

  beforeMount () {
    this.setAreaScaleYPadding()
    this.setPredictionScaleYPadding()
    this.setSolarRadationScaleYPadding()
    this.setTemperatureScaleYPadding()
    this.setTemperatureDifferenceScaleYPadding()
  }

  mounted () {
    window.addEventListener('resize', this.resizeWidth, false)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeWidth, false)
  }

  public resizeWidth () {
    setTimeout(this.setResizeWidth, 200)
  }

  public setResizeWidth () {
    const userAgent = window.navigator.userAgent.toLowerCase()
    let canvas: any = document.getElementById('line-chart')
    let canvasWidth = canvas.style.width.replace(/px/g, '')
    this.slideWidth = parseInt(canvasWidth) - 150
    this.subSlideWidth = this.slideWidth
    if (userAgent.indexOf('firefox') !== -1) {
      this.subSlideWidth += 15
    }
    this.setIcon()
    this.setWaterControl()
    this.changeNewsBoardData()
    this.changeExternalLinkData()
  }

  public setWaterControl () {
    // 水管理名称の表示を追加
    const waterData = []
    const oneDayWidth = (this.slideWidth - 15) / (this.label.length - 1)
    const masterWaterData = JSON.parse(Session.getMasterWaterControls()!)

    for (var i in this.label) {
      for (var j in masterWaterData) {
        const year = this.label[i].getFullYear()
        const month = '0' + (this.label[i].getMonth() + 1)
        const date = '0' + this.label[i].getDate()
        const day = '' + year + month.slice(-2) + date.slice(-2)

        if (day === String(masterWaterData[j].center_date)) {
          const leftPosition = parseInt(i) * oneDayWidth
          let topPosition = '0'
          if ((parseInt(j) % 2) === 0) {
            topPosition = '-5'
          } else {
            topPosition = '-25'
          }

          waterData.push({
            top: topPosition,
            left: leftPosition,
            water_control_name: masterWaterData[j].water_control_name
          })
        }
      }
    }
    this.displayWaterData = waterData
  }

  private setIcon () {
    this.imageRecordsData = JSON.parse(Session.getImageRecords()!)
    this.pointIconsData = JSON.parse(Session.getPointIcons()!)
    this.riskRecordsData = JSON.parse(Session.getRiskRecords()!)
    this.harvestStatus = Number(Session.getHarvestStatusData())
    this.harvestStatusUpdateData = Session.getHarvestStatusUpdateData()
    let settingBtn: any = document.getElementsByClassName('icon-setting-btn')
    setTimeout(this.changePosition, 200)
  }

  /* あい作 任意アイコンの判定 */
  private judgmentPointIcon (pointIcon: number) {
    switch (pointIcon) {
      // カメラ
      case 1:
        return require('@/assets/icon/aisaku_camera_icon.svg')

      // ★
      case 2:
        return require('@/assets/icon/black_star_icon.svg')

      // ☆
      case 3:
        return require('@/assets/icon/star_icon.svg')

      // !
      case 4:
        return require('@/assets/icon/exclamation_mark_icon.svg')

      // 不明
      default:
        return null
    }
  }

  private changePosition () {
    this.imageData = []
    this.pointIconData = []
    this.riskData = []
    const updateDate = new Date(this.harvestStatusUpdateData)
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + DateClass.toDoubleDigits(updateDate.getDate())
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      let year = this.label[j].getFullYear()
      let month = '0' + (this.label[j].getMonth() + 1)
      let date = '0' + this.label[j].getDate()
      let day = '' + this.label[j].getFullYear() + month.slice(-2) + date.slice(-2)
      for (let i in this.imageRecordsData) {
        if (day === String(this.imageRecordsData[i].record_date)) {
          let position = parseInt(j) * oneDayWidth
          this.imageData.push({
            left: position,
            record_date: this.imageRecordsData[i].record_date
          })
        }
      }
      for (let i in this.pointIconsData) {
        if (day === String(this.pointIconsData[i].record_date)) {
          let position = (parseInt(j) * oneDayWidth)
          if (this.pointIconsData[i].point_icon !== null) {
            this.pointIconData.push({
              left: position,
              record_date: this.pointIconsData[i].record_date,
              icon: this.judgmentPointIcon(this.pointIconsData[i].point_icon)
            })
          }
        }
      }
      for (let i in this.riskRecordsData) {
        if (day === String(this.riskRecordsData[i].record_date)) {
          let position = (parseInt(j) * oneDayWidth) - 5
          let fixedIcon = false
          let riskName
          this.riskDetailData = []
          for (let k in this.riskRecordsData[i].risk_details) {
            // リスク詳細が1件かつ固定リスク(組織が設定していないリスク)の場合にtrueとリスク名をセット
            if (this.riskRecordsData[i].risk_details.length === 1 && this.riskRecordsData[i].risk_details[k].is_fixed_risk) {
              fixedIcon = true
              riskName = this.riskRecordsData[i].risk_details[k].risk_name
            }
            // リスク詳細表示用にセット
            this.riskDetailData.push({
              risk_name: this.riskRecordsData[i].risk_details[k].risk_name,
              risk_item_name: this.riskRecordsData[i].risk_details[k].risk_item_name
            })
          }
          this.riskData.push({
            left: position,
            is_fixed_icon: fixedIcon,
            risk_name: riskName,
            risk_detail_list: this.riskDetailData,
            record_date: this.riskRecordsData[i].record_date
          })
        }
      }
      if (this.harvestStatus === harvestStatus.CHANCEL || this.harvestStatus === harvestStatus.HARVESTE_INSTRUCTIONS || this.harvestStatus === harvestStatus.HARVESTED) {
        if (day === formingDate) {
          this.showHarvestStatus = true
          this.harvestStatusPosition = parseInt(j) * oneDayWidth
          this.harvestStatusUpdateData = formingDate
          if (this.harvestStatus === harvestStatus.CHANCEL) {
            this.harvestStatusName = '中止'
          } else if (this.harvestStatus === harvestStatus.HARVESTE_INSTRUCTIONS) {
            this.harvestStatusName = '収穫指示'
          } else {
            this.harvestStatusName = '収穫済み'
          }
        }
      } else {
        this.showHarvestStatus = false
      }
    }
  }

  private newsBoardIcons: any = []
  private externalLinkIcons: any = []

  private async getNewsBoardFile (id: number, content_name: string) {
    const objectURL = await GetNewsBoardFileApi.getNewsBoardFile(id)
    if (typeof objectURL === 'string') {
      let link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectURL
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectURL)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }

  private async getExternalLinkFile (id: number, content_name: string) {
    const objectPath: any = await GetExternalLinkFileApi.getExternalLinkFile(id)
    if (typeof objectPath === 'string') {
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.href = objectPath
      link.download = content_name
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(objectPath)
    } else {
      Vue.prototype.$alert.toast({ text: 'ファイル取得に失敗しました。', type: 1 })
    }
  }

  private changeNewsBoardData () {
    let newsBoardData = this.newsBoardContents.reduce(function (rv: any, x: any) {
      (rv[x.record_date] = rv[x.record_date] || []).push(x)
      return rv
    }, {})

    for (let i in newsBoardData) {
      newsBoardData[i].sort(function (a: any, b: any) {
        // かわらばん名の昇順
        if (a.news_board_name < b.news_board_name) {
          return -1
        }
        if (a.news_board_name > b.news_board_name) {
          return 1
        }
        // 記事名の昇順
        if (a.content_name < b.content_name) {
          return -1
        }
        if (a.content_name > b.content_name) {
          return 1
        }
        return 0
      })
    }

    this.newsBoardIcons = []
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      const year = this.label[j].getFullYear()
      const month = '0' + (this.label[j].getMonth() + 1)
      const date = '0' + this.label[j].getDate()
      const day = '' + year + '-' + month.slice(-2) + '-' + date.slice(-2)
      for (let i in newsBoardData) {
        if (day === DateClass.dateToStringYmd(new Date(i), '-')) {
          let position = (parseInt(j) * oneDayWidth) - 6
          const data = this.groupByCategory(newsBoardData[i])
          this.newsBoardIcons.push({
            left: position,
            record_date: DateClass.dateToStringYmd(this.label[j], '年月日'),
            details: data,
            category_id: this.getNewsBoardCategoryId(data),
            category_name: this.getNewsBoardCategoryName(this.getNewsBoardCategoryId(data))
          })
        }
      }
    }
  }

  private getNewsBoardCategoryName (id: any) {
    for (let i in this.constantValue.news_board_categories) {
      if (this.constantValue.news_board_categories[i].category_id === id) {
        return this.constantValue.news_board_categories[i].category_name
      }
    }
    return '複数分類'
  }

  private getNewsBoardCategoryId (data: any) {
    if (Object.keys(data).length === 1) {
      for (let categoryId in data) {
        return parseInt(categoryId)
      }
    } else {
      return null
    }
  }

  private groupByCategory (data: any) {
    const list = data.reduce(function (rv: any, x: any) {
      (rv[x.category_id] = rv[x.category_id] || []).push(x)
      return rv
    }, {})

    return list
  }

  private changeExternalLinkData () {
    let externalLinkData = this.externalLinkContents.reduce(function (rv: any, x: any) {
      (rv[x.record_date] = rv[x.record_date] || []).push(x)
      return rv
    }, {})

    for (let i in externalLinkData) {
      externalLinkData[i].sort(function (a: any, b: any) {
        // 外部連携名の昇順
        a.external_link_name = 'external_link_name_test'
        if (a.external_link_name < b.external_link_name) {
          return -1
        }
        if (a.external_link_name > b.external_link_name) {
          return 1
        }
        // 連携名の昇順
        if (a.content_name < b.content_name) {
          return -1
        }
        if (a.content_name > b.content_name) {
          return 1
        }
        return 0
      })
    }

    this.externalLinkIcons = []
    const oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      const year = this.label[j].getFullYear()
      const month = '0' + (this.label[j].getMonth() + 1)
      const date = '0' + this.label[j].getDate()
      const day = '' + year + '-' + month.slice(-2) + '-' + date.slice(-2)
      for (let i in externalLinkData) {
        if (day === i) {
          const position = (parseInt(j) * oneDayWidth) - 5
          this.externalLinkIcons.push({
            left: position,
            record_date: month.slice(-2) + '月' + date.slice(-2) + '日',
            detail: externalLinkData[i]
          })
        }
      }
    }
  }

  private newsBoardContents: any = []
  private externalLinkContents: any = []

  private getNewsBoardContentsList () {
    (async () => {
      const data = {
        variety_id: JSON.parse(Session.getVarietyId()!),
        district_id: JSON.parse(Session.getDistrictId()!)
      }

      const result = await newsBoardContentsListApi.getNewsBoardContentsList(data)

      if (result.isOk()) {
        this.newsBoardContents = result.getPayload().news_board_contents
        this.changeNewsBoardData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private getExternalLinkContentsList () {
    (async () => {
      const data = {
        variety_id: JSON.parse(Session.getVarietyId()!),
        district_id: JSON.parse(Session.getDistrictId()!)
      }

      const result = await ExternalLinkContentsListApi.getExternalLinkContentsList(data)

      if (result.isOk()) {
        this.externalLinkContents = result.getPayload().external_link_contents
        this.changeExternalLinkData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  public updateDisplayYear () {
    this.chartOptions.annotation.annotations = []
    this.plantingId = Session.getPlantingId()!

    this.createChartData()
    this.createAreaChartData()
    this.createPrecipitationChart()
    this.createGrowthHightChart()
    this.createNdviChart()
    this.createSolarRadationChart()
    this.createTemperatureChart()
    this.createTemperatureDifferenceChart()
    let growthStageList = JSON.parse(Session.getGrowthStage()!)
    this.createStageBar(growthStageList)

    this.displayGraph()
    this.jugeShowCanonData()

    this.setAreaScaleYPadding()
    this.setPredictionScaleYPadding()
    this.setSolarRadationScaleYPadding()
    this.setTemperatureScaleYPadding()
    this.setTemperatureDifferenceScaleYPadding()

    // 再レンダリング
    this.setIcon()
    this.setWaterControl()

    // かわらばん情報を取得していなければAPIをたたく
    if (this.newsBoardContents.length === 0) {
      this.getNewsBoardContentsList()
    } else {
      this.changeNewsBoardData()
    }
    // 外部連携情報を取得していなければAPIをたたく
    if (this.externalLinkContents.length === 0) {
      this.getExternalLinkContentsList()
    } else {
      this.changeExternalLinkData()
    }

    const intGraphRange = [this.label[0], this.label.slice(-1)[0]].map((e: any) => DateClass.dateToInt(e))
    this.$store.commit('fieldDetailsState/setGraphRange', intGraphRange)
    if (this.initSliderDate) {
      const index = this.label.findIndex((e: any) => DateClass.isEqual(e, new Date()))
      const date = DateClass.adjust(index === -1 ? this.label.slice(-1)[0] : this.label[index])
      this.$store.commit('dateChoiceState/setChangeDate', DateClass.dateToInt(date))
      this.initSliderDate = false
    }
  }

  private showCanonData: boolean = true

  private jugeShowCanonData () {
    const allGraphData: any = JSON.parse(Session.getAllGraphData()!)
    if (!allGraphData) {
      return
    }
    if (!allGraphData.is_fieldcam_sensor &&
        allGraphData.valid_stem_numbers === null &&
        allGraphData.temp_stem_numbers === null &&
        allGraphData.invalid_stem_numbers === null &&
        allGraphData.valid_spads === null &&
        allGraphData.temp_spads === null &&
        allGraphData.invalid_spads === null &&
        allGraphData.valid_plant_heights === null &&
        allGraphData.temp_plant_heights === null &&
        allGraphData.invalid_plant_heights === null) {
      this.showCanonData = false
      this.showCanonText = false
      this.chartOptions.scales.yAxes[1].scaleLabel.labelString = this.rangeLabel('left')
    } else {
      this.showCanonData = true
      this.showCanonText = true

      const legend1: any = document.getElementById('legend-1')
      const child: any = legend1.getElementsByTagName('li')
      const br: any = legend1.getElementsByTagName('br')
      if (br.length === 0 || child.length === 0) {
        setTimeout(this.jugeShowCanonData, 200)
        return
      }
      br[3].classList.remove('hide')
      br[5].classList.remove('hide')
      br[6].classList.remove('hide')
      child[10].classList.remove('hide')
      child[13].classList.remove('hide')
      child[19].classList.remove('hide')
      child[22].classList.remove('hide')
      child[28].classList.remove('hide')
      child[31].classList.remove('hide')
      this.chartOptions.scales.yAxes[1].scaleLabel.labelString = this.rangeLabel('left')
    }
    this.$emit('show-canon-data', this.showCanonData)
  }

  private showCanonText: boolean = false

  private getShowPropriety (key: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    const type = Session.getStemNumberType()!

    if (type === '1' && key === 'stemNumberM2') {
      return true
    } else if (type === '2' && key === 'stemNumber') {
      return true
    }

    if (settingData !== null) {
      return true
    } else {
      if (key === 'integrationTemperature' ||
          key === 'stemNumber' ||
          key === 'integratedInsolation' ||
          key === 'solarRadation' ||
          key === 'stemNumberM2' ||
          key === 'spad' ||
          key === 'growthHeight' ||
          key === 'waterLevel' ||
          key === 'leafAge') {
        return false
      } else {
        return true
      }
    }
  }

  /* chartの基本データ */
  public createChartData () {
    this.chartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          pointRadius: 0,
          pointBorderColor: this.performancePointBgColor,
          pointBackgroundColor: this.performancePointBgColor,
          data: this.createdActualResultsData('integration_temperature'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算温度(℃)',
          backgroundColor: '#6a9eba',
          borderColor: '#6a9eba',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標積算温度(℃)',
          backgroundColor: 'rgba(15, 101, 148, 0.3)',
          borderColor: 'rgba(15, 101, 148, 0.3)',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          data: this.createdGoalData('goal_integration_temperature'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: this.getShowPropriety('integrationTemperature'),
          spanGaps: true,
          borderDash: [5, 5],
          pointBorderColor: this.predictionPointBgColor,
          pointBackgroundColor: this.predictionPointBgColor,
          data: this.createPredictionTemperature(),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績茎数(本/株)',
          backgroundColor: '#31e7ba',
          borderColor: '#31e7ba',
          hidden: this.getShowPropriety('stemNumber'),
          fill: false,
          spanGaps: true,
          data: this.createdActualResultsData('stem_number'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較茎数(本/株)',
          backgroundColor: '#7EECD1',
          borderColor: '#7EECD1',
          fill: false,
          hidden: this.getShowPropriety('stemNumber'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '指標茎数(本/株)',
          backgroundColor: 'rgba(49, 231, 186, 0.3)',
          borderColor: 'rgba(49, 231, 186, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('stemNumber'),
          data: this.createdGoalData('goal_stem_number'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績茎数(本/平米)',
          backgroundColor: '#31e7ba',
          borderColor: '#31e7ba',
          hidden: this.getShowPropriety('stemNumberM2'),
          fill: false,
          spanGaps: true,
          data: this.createdActualResultsData('stem_number_m2'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較茎数(本/平米)',
          backgroundColor: '#7EECD1',
          borderColor: '#7EECD1',
          fill: false,
          hidden: this.getShowPropriety('stemNumberM2'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標茎数(本/平米)',
          backgroundColor: 'rgba(49, 231, 186, 0.3)',
          borderColor: 'rgba(49, 231, 186, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('stemNumberM2'),
          data: this.createdGoalData('goal_stem_number_m2'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-茎数(本/株)',
          backgroundColor: '#59723A',
          borderColor: '#59723A',
          hidden: this.getShowPropriety('stemNumber'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('valid_stem_numbers', 'stem_number')),
          data: this.createdCanonActualResultsData('valid_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-茎数(本/株)',
          backgroundColor: '#59723A',
          borderColor: '#59723A',
          fill: false,
          hidden: this.getShowPropriety('stemNumber'),
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('temp_stem_numbers', 'stem_number')),
          borderDash: [3, 3],
          data: this.createdCanonActualResultsData('temp_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-茎数(本/株)',
          backgroundColor: '#59723A',
          borderColor: '#59723A',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('stemNumber'),
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('invalid_stem_numbers', 'stem_number')),
          data: this.createdCanonActualResultsData('invalid_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-茎数(本/株)',
          backgroundColor: '#96A584',
          borderColor: '#96A584',
          hidden: this.getShowPropriety('stemNumber'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('valid_stem_numbers', 'stem_number')),
          data: this.createCanonComparisonData('valid_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-茎数(本/株)',
          backgroundColor: '#96A584',
          borderColor: '#96A584',
          fill: false,
          hidden: this.getShowPropriety('stemNumber'),
          spanGaps: false,
          borderDash: [3, 3],
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('temp_stem_numbers', 'stem_number')),
          data: this.createCanonComparisonData('temp_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-茎数(本/株)',
          backgroundColor: '#96A584',
          borderColor: '#96A584',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('stemNumber'),
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('invalid_stem_numbers', 'stem_number')),
          data: this.createCanonComparisonData('invalid_stem_numbers', 'stem_number'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績葉色値',
          backgroundColor: '#F94D83',
          borderColor: '#F94D83',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('spad'),
          data: this.createdActualResultsData('spad'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較葉色値',
          backgroundColor: '#F68FB0',
          borderColor: '#F68FB0',
          fill: false,
          hidden: this.getShowPropriety('spad'),
          spanGaps: true,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '指標葉色値',
          backgroundColor: 'rgba(249, 77, 131, 0.3)',
          borderColor: 'rgba(249, 77, 131, 0.3)',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('spad'),
          data: this.createdGoalData('goal_spad'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-葉色',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          hidden: this.getShowPropriety('stemNumber'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('valid_spads', 'spad')),
          data: this.createdCanonActualResultsData('valid_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-葉色',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          fill: false,
          borderDash: [3, 3],
          hidden: this.getShowPropriety('stemNumber'),
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('temp_spads', 'spad')),
          data: this.createdCanonActualResultsData('temp_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-葉色',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('stemNumber'),
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('invalid_spads', 'spad')),
          data: this.createdCanonActualResultsData('invalid_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-葉色',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          hidden: this.getShowPropriety('stemNumber'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('valid_spads', 'spad')),
          data: this.createCanonComparisonData('valid_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-葉色',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          fill: false,
          borderDash: [3, 3],
          hidden: this.getShowPropriety('stemNumber'),
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('temp_spads', 'spad')),
          data: this.createCanonComparisonData('temp_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-葉色',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('stemNumber'),
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('invalid_spads', 'spad')),
          data: this.createCanonComparisonData('invalid_spads', 'spad'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績草丈(cm)',
          backgroundColor: '#0B8C41',
          borderColor: '#0B8C41',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('growthHeight'),
          data: this.createdActualResultsData('growth_height'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較草丈(cm)',
          backgroundColor: '#68B588',
          borderColor: '#68B588',
          hidden: this.getShowPropriety('growthHeight'),
          spanGaps: true,
          fill: false,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'bar',
          label: '指標草丈(cm)',
          backgroundColor: 'rgba(11, 140, 65, 0.3)',
          borderColor: 'rgba(11, 140, 65, 0.3)',
          barThickness: 10,
          fill: false,
          hidden: this.getShowPropriety('growthHeight'),
          data: this.createdGoalData('goal_growth_height'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-草丈(cm)',
          backgroundColor: '#446D62',
          borderColor: '#446D62',
          hidden: this.getShowPropriety('growthHeight'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('valid_plant_heights', 'plant_height')),
          data: this.createdCanonActualResultsData('valid_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-草丈(cm)',
          backgroundColor: '#446D62',
          borderColor: '#446D62',
          fill: false,
          borderDash: [3, 3],
          hidden: this.getShowPropriety('growthHeight'),
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('temp_plant_heights', 'plant_height')),
          data: this.createdCanonActualResultsData('temp_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績-画像解析-草丈(cm)',
          backgroundColor: '#446D62',
          borderColor: '#446D62',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('growthHeight'),
          pointRadius: this.judgePointRadius(this.createdCanonActualResultsData('invalid_plant_heights', 'plant_height')),
          data: this.createdCanonActualResultsData('invalid_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-草丈(cm)',
          backgroundColor: '#8AA29C',
          borderColor: '#8AA29C',
          hidden: this.getShowPropriety('growthHeight'),
          fill: false,
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('valid_plant_heights', 'plant_height')),
          data: this.createCanonComparisonData('valid_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-草丈(cm)',
          backgroundColor: '#8AA29C',
          borderColor: '#8AA29C',
          fill: false,
          borderDash: [3, 3],
          hidden: this.getShowPropriety('growthHeight'),
          spanGaps: false,
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('temp_plant_heights', 'plant_height')),
          data: this.createCanonComparisonData('temp_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較-画像解析-草丈(cm)',
          backgroundColor: '#8AA29C',
          borderColor: '#8AA29C',
          fill: false,
          spanGaps: false,
          borderDash: [5, 5],
          hidden: this.getShowPropriety('growthHeight'),
          pointRadius: this.judgePointRadius(this.createCanonComparisonData('invalid_plant_heights', 'plant_height')),
          data: this.createCanonComparisonData('invalid_plant_heights', 'plant_height'),
          datalabels: {
            display: false
          },
          order: 3
        }
      ]
    }
  }

  private rangeLabel (position: string) {
    const type = Session.getStemNumberType()!

    if (position === 'left') {
      if (this.showCanonData) {
        if (type === '1' || type === '3') {
          return '草丈・葉色値・葉色・茎数(株)'
        } else {
          return '草丈・葉色値・葉色'
        }
      } else {
        if (type === '1' || type === '3') {
          return '草丈・葉色値・茎数(株)'
        } else {
          return '草丈・葉色値'
        }
      }
    } else {
      if (type === '2' || type === '3') {
        return '積算温度・茎数(平米)'
      } else {
        return '積算温度'
      }
    }
  }

  public createAreaChartData () {
    this.areaChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績水位(cm)',
          backgroundColor: '#51B4E9',
          borderColor: '#51B4E9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('waterLevel'),
          pointRadius: 0,
          data: this.createdActualResultsData('water_level'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較水位(cm)',
          backgroundColor: '#92CDED',
          borderColor: '#92CDED',
          hidden: this.getShowPropriety('waterLevel'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標水位(cm)',
          backgroundColor: 'rgba(81, 180, 233, 0.3)',
          borderColor: 'rgba(81, 180, 233, 0.3)',
          fill: true,
          hidden: this.getShowPropriety('waterLevel'),
          pointRadius: 0,
          spanGaps: true,
          data: this.createdGoalData('plan_water_level'), // なし
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績水温(℃)',
          backgroundColor: '#51DEE9',
          borderColor: '#51DEE9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('waterTemp'),
          pointRadius: 0,
          data: this.createdActualResultsData('water_temp'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較水温(℃)',
          backgroundColor: '#92EDEA',
          borderColor: '#92EDEA',
          hidden: this.getShowPropriety('waterTemp'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標水温(℃)',
          backgroundColor: 'rgba(81, 222, 233, 0.3)',
          borderColor: 'rgba(81, 222, 233, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('waterTemp'),
          data: this.createdGoalData('goal_water_temp'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績地温(℃)',
          backgroundColor: '#E9AC51',
          borderColor: '#E9AC51',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('groundTemp'),
          pointRadius: 0,
          data: this.createdActualResultsData('ground_temp'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較地温(℃)',
          backgroundColor: '#EDCC92',
          borderColor: '#EDCC92',
          hidden: this.getShowPropriety('groundTemp'),
          fill: false,
          spanGaps: true,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標地温(℃)',
          backgroundColor: 'rgba(233, 172, 81, 0.3)',
          borderColor: 'rgba(233, 172, 81, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('groundTemp'),
          data: this.createdGoalData('goal_ground_temp'),
          datalabels: {
            display: false
          },
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績pH',
          backgroundColor: '#E9516B',
          borderColor: '#E9516B',
          fill: false,
          hidden: this.getShowPropriety('ph'),
          spanGaps: true,
          pointRadius: 0,
          data: this.createdActualResultsData('ph'),
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較pH',
          backgroundColor: '#ED92A4',
          borderColor: '#ED92A4',
          hidden: this.getShowPropriety('ph'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '指標pH',
          backgroundColor: 'rgba(233, 81, 107, 0.3)',
          borderColor: 'rgba(233, 81, 107, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('ph'),
          data: this.createdGoalData('goal_ph'),
          datalabels: {
            display: false
          },
          order: 4
        }
      ]
    }
  }

  public createPrecipitationChart () {
    this.predictionChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績積算降水量(mm)',
          backgroundColor: '#51B4E9',
          borderColor: '#51B4E9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('soilStatus'),
          pointRadius: 0,
          data: this.createdActualResultsData('integrated_precipitation_amount'),
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算降水量(mm)',
          backgroundColor: '#92CDED',
          borderColor: '#92CDED',
          hidden: this.getShowPropriety('soilStatus'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測積算降水量(mm)',
          backgroundColor: 'rgba(81, 180, 233, 0.3)',
          borderColor: 'rgba(81, 180, 233, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('soilStatus'),
          data: this.createdGoalData('goal_integrated_precipitation_amount'),
          datalabels: {
            display: false
          }
        }
      ]
    }
  }

  public createGrowthHightChart () {
    this.growthHightChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績草丈(cm)',
          backgroundColor: '#0B8C41',
          borderColor: '#0B8C41',
          fill: false,
          spanGaps: true,
          hidden: true,
          data: this.createdActualResultsData('growth_height'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較草丈(cm)',
          backgroundColor: '#68B588',
          borderColor: '#68B588',
          hidden: true,
          spanGaps: true,
          fill: false,
          data: [],
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'bar',
          label: '実績桿長(cm)',
          backgroundColor: '#2aaf1e',
          borderColor: '#2aaf1e',
          fill: false,
          stack: 'actual',
          spanGaps: true,
          hidden: this.getShowPropriety('stemLength'),
          data: this.createdActualResultsData('stem_length'),
          barThickness: 10,
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較桿長(cm)',
          backgroundColor: '#86cf7f',
          borderColor: '#86cf7f',
          hidden: this.getShowPropriety('stemLength'),
          spanGaps: true,
          fill: false,
          stack: 'comparision',
          data: [],
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'bar',
          label: '実績穂長(cm)',
          backgroundColor: '#feac2a',
          borderColor: '#feac2a',
          fill: false,
          stack: 'actual',
          spanGaps: true,
          hidden: this.getShowPropriety('earLength'),
          data: this.createdActualResultsData('ear_length'),
          barThickness: 10,
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較穂長(cm)',
          backgroundColor: '#fbcd84',
          borderColor: '#fbcd84',
          hidden: this.getShowPropriety('earLength'),
          stack: 'comparision',
          spanGaps: true,
          fill: false,
          data: [],
          datalabels: {
            display: false
          },
          order: 1
        }
      ]
    }
  }

  public createNdviChart () {
    this.ndviChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績NDVI',
          backgroundColor: '#4D83F9',
          borderColor: '#4D83F9',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('leafAge'),
          data: this.createdActualResultsData('leaf_age'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較NDVI',
          backgroundColor: '#50A17D',
          borderColor: '#50A17D',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('leafAge'),
          data: [],
          datalabels: {
            display: false
          },
          order: 1
        }
      ]
    }
  }

  public createSolarRadationChart () {
    this.solarRadationChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績日射量(MJ/m2)',
          backgroundColor: '#FFCE48',
          borderColor: '#FFCE48',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('solarRadation'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('solar_radation')),
          data: this.createdActualResultsData('solar_radation'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較日射量(MJ/m2)',
          backgroundColor: '#FFD972',
          borderColor: '#FFD972',
          hidden: this.getShowPropriety('solarRadation'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測日射量(MJ/m2)',
          backgroundColor: 'rgba(255, 206, 72, 0.3)',
          borderColor: 'rgba(255, 206, 72, 0.3)',
          fill: true,
          spanGaps: true,
          pointRadius: this.judgePointRadius(this.createdGoalData('solar_radation')),
          hidden: this.getShowPropriety('solarRadation'),
          data: this.createdGoalData('solar_radation'),
          datalabels: {
            display: false
          },
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績積算日射量(MJ/m2)',
          backgroundColor: '#FF8B48',
          borderColor: '#FF8B48',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('integratedInsolation'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('integrated_insolation')),
          data: this.createdActualResultsData('integrated_insolation'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較積算日射量(MJ/m2)',
          backgroundColor: '#FFA876',
          borderColor: '#FFA876',
          hidden: this.getShowPropriety('integratedInsolation'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '予測積算日射量(MJ/m2)',
          backgroundColor: 'rgba(255, 139, 72, 0.3)',
          borderColor: 'rgba(255, 139, 72, 0.3)',
          fill: true,
          spanGaps: true,
          hidden: this.getShowPropriety('integratedInsolation'),
          data: this.createdGoalData('goal_integrated_insolation'),
          datalabels: {
            display: false
          },
          order: 3
        }
      ]
    }
  }

  public createTemperatureChart () {
    this.temperatureChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績日平均気温(℃)',
          backgroundColor: '#446D62',
          borderColor: '#446D62',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperature'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature')),
          data: this.createdActualResultsData('temperature'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較日平均気温(℃)',
          backgroundColor: '#8AA29C',
          borderColor: '#8AA29C',
          hidden: this.getShowPropriety('temperature'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績最高気温(℃)',
          backgroundColor: '#E9516B',
          borderColor: '#E9516B',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureHighest'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_highest')),
          data: this.createdActualResultsData('temperature_highest'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較最高気温(℃)',
          backgroundColor: '#ED92A4',
          borderColor: '#ED92A4',
          hidden: this.getShowPropriety('temperatureHighest'),
          spanGaps: false,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績最低気温(℃)',
          backgroundColor: 'rgba(143, 143, 143, 0.3)',
          borderColor: '#51B4E9',
          fill: '-2',
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureLowest'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_lowest')),
          data: this.createdActualResultsData('temperature_lowest'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較最低気温(℃)',
          backgroundColor: 'rgba(143, 143, 143, 0.2)',
          borderColor: '#c1dfef',
          hidden: this.getShowPropriety('temperatureLowest'),
          spanGaps: true,
          fill: '-2',
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績寒暖差(℃)',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          hidden: true
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較寒暖差(℃)',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          hidden: true
        }
      ]
    }
  }

  public createTemperatureDifferenceChart () {
    this.temperatureDifferenceChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績寒暖差(℃)',
          backgroundColor: '#9D0538',
          borderColor: '#9D0538',
          fill: false,
          spanGaps: true,
          hidden: this.getShowPropriety('temperatureDifference'),
          pointRadius: this.judgePointRadius(this.createdActualResultsData('temperature_difference')),
          data: this.createdActualResultsData('temperature_difference'),
          datalabels: {
            display: false
          },
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較寒暖差(℃)',
          backgroundColor: '#BF6483',
          borderColor: '#BF6483',
          hidden: this.getShowPropriety('temperatureDifference'),
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [],
          datalabels: {
            display: false
          },
          order: 2
        }
      ]
    }
  }

  public active () {
    this.isActive = !this.isActive
  }

  /* 今日のポイントのみ色を変える(実測) */
  public performancePointBgColor () {
    let points = this.createdActualResultsData('integration_temperature')
    let todayColor = '#ff0000'
    let defaultColor = '#0f6594'

    // すべてdefaultColorの配列を作る
    let bgColors = new Array(Object.keys(points).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = points.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = points.lastIndexOf(lastDayVal)

      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* 今日のポイントのみ色を変える(予測) */
  public predictionPointBgColor () {
    let points = this.createPredictionTemperature()
    let plantingData = this.createdActualResultsData('integration_temperature')
    let todayColor = '#ff0000'
    let defaultColor = '#0f6594'

    // すべてdefaultColorの配列を作る
    var bgColors = new Array(Object.keys(plantingData).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val: any) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)

      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* chartのラベルを作成 */
  public getLabels () {
    if (this.label.length > 0) {
      this.graphMaxDay = DateClass.addDate(this.label.slice(-1)[0], 1)
      this.$store.commit('fieldDetailsState/setMaxDate', this.graphMaxDay)
      return this.label
    }

    const labels: any[] = []
    const graphData = JSON.parse(Session.getGraphData()!)
    const graphLastDay = parseInt(Object.keys(graphData).pop()!)
    const harvestDate = parseInt(Session.getHarvestDate()!)
    const masterData = JSON.parse(Session.getMasterData()!)
    const maxHarvestTime = parseInt(JSON.parse(Session.getHarvestTime()!))

    let masterLastDay: any = 0
    if (masterData !== null) {
      masterLastDay = parseInt(Object.keys(masterData).pop()!)
    }

    // 始まりを播種日-10日にする
    const plantingDay = String(JSON.parse(Session.getPlantingDay()!))

    if (plantingDay === null) {
      return []
    }
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 10)

    // 全て数値に変換
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const updateDate = new Date(harvestStatusDay)
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + DateClass.toDoubleDigits(updateDate.getDate())
    const statusChangeDate = parseInt(formingDate)
    let maxDay: any

    if (status === harvestStatus.CHANCEL || status === harvestStatus.HARVESTE_INSTRUCTIONS) {
      let day: any
      /*
      * ①収穫適期の最終
      * ②マスターデータの収穫適期
      * ③実測データの最終日
      * どれが一番大きいか
      */
      if (isNaN(masterLastDay) && isNaN(graphLastDay) && isNaN(maxHarvestTime)) {
        // 全てのデータがない場合
        this.$emit('show-alert')
        return
      } else if (isNaN(masterLastDay) && isNaN(graphLastDay)) {
        // マスターデータと実測データがない
        day = maxHarvestTime
      } else if (isNaN(masterLastDay) && isNaN(maxHarvestTime)) {
        // マスターデータと収穫適期の最終日がない
        day = graphLastDay
      } else if (isNaN(graphLastDay) && isNaN(maxHarvestTime)) {
        // 実測データと収穫適期の最終日がない
        day = masterLastDay
      } else if (isNaN(masterLastDay)) {
        // マスターデータがない
        day = this.judgeMaxDay(graphLastDay, maxHarvestTime)
      } else if (isNaN(graphLastDay)) {
        // 実測データがない
        day = this.judgeMaxDay(masterLastDay, maxHarvestTime)
      } else if (isNaN(maxHarvestTime)) {
        // 収穫適期の最終日がない
        day = this.judgeMaxDay(graphLastDay, masterLastDay)
      } else {
        // 3つすべて存在する場合
        if (masterLastDay >= graphLastDay && masterLastDay >= maxHarvestTime) {
          day = masterLastDay
        } else if (graphLastDay >= masterLastDay && graphLastDay >= maxHarvestTime) {
          day = graphLastDay
        } else if (maxHarvestTime >= masterLastDay && maxHarvestTime >= graphLastDay) {
          day = maxHarvestTime
        }
      }
      // ステータス変更日が①②③より大きいか判定
      if (statusChangeDate > day) {
        maxDay = day
      } else {
        if (day === graphLastDay && statusChangeDate > masterLastDay && statusChangeDate > maxHarvestTime) {
          maxDay = statusChangeDate
        } else {
          maxDay = harvestDate
        }
      }
    } else {
      maxDay = harvestDate
    }

    // 最大日を+30日にする
    this.graphMaxDay = DateClass.formingDate(maxDay)
    this.graphMaxDay.setDate(this.graphMaxDay.getDate() + 30)
    this.$store.commit('fieldDetailsState/setMaxDate', this.graphMaxDay)

    for (var i = minDay; i < this.graphMaxDay; i = new Date(i.setDate(i.getDate() + 1))) {
      labels.push(i)
    }
    this.label = labels
    this.setGraphRange([minDay, this.graphMaxDay])
    return labels
  }

  private setGraphRange (newRange: any[]) {
    this.graphRange = newRange
  }

  private onChangeGraphRange (date: any) {
    if (!this.graphRange[0] || !this.graphRange[1]) {
      this.label = []
    } else {
      this.setGraphRange([DateClass.addDate(this.graphRange[0], -1), this.graphRange[1]])
      const labels: any[] = []
      for (var i = this.graphRange[0]; i < this.graphRange[1]; i = new Date(i.setDate(i.getDate() + 1))) {
        labels.push(i)
      }
      this.label = labels
    }
    this.initSliderDate = true
    this.updateDisplayYear()
  }

  /* グラフ描画領域の最大値を判定 */
  public judgeMaxDay (a: number, b: number) : any {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  // 予測積算温度
  public createPredictionTemperature () {
    let plantingData = this.createdActualResultsData('integration_temperature')
    let predictionData = JSON.parse(Session.getPredictionData()!)
    let array: any[] = []
    let filterArray: any[][] = []
    const predictionTemp: any[] = []

    // 実測データの最終日を取得
    let graphData = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    let date: any = DateClass.formingDate(lastDay)

    // 目標データがない場合は空を返す
    if (predictionData === null) {
      return []
    }

    for (var i in predictionData) {
      array = []

      for (var j = 0; j < this.label.length; j++) {
        let day = DateClass.formingDate(i)

        if (this.label[j] < date) {
          array.push(null)
        } else {
          if (this.label[j].getTime() === day.getTime()) {
            array.push(predictionData[i].integration_temperature)
          } else {
            array.push(null)
          }
        }
      }
      filterArray.push(array)
    }

    let graphDataLength = Object.keys(predictionData).length
    for (var k = 0; k < filterArray[0].length; k++) {
      let data: number = 0
      for (var l = 0; l < graphDataLength; l++) {
        if (filterArray[l][k] === null) {
          filterArray[l][k] = 0
        }
        data += filterArray[l][k]
      }

      if (data !== 0) {
        predictionTemp.push(data)
      } else {
        predictionTemp.push(null)
      }
    }

    // 予測線の始まりは実績の最終日
    if (plantingData.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)

      predictionTemp[key] = plantingData[key]
    }

    return predictionTemp
  }

  /* 比較データの作成 */
  public createComparisonData () {
    if (this.$store.state.graphToggleState.hiddenComparisonData) {
      return
    }

    let comparisonData = JSON.parse(Session.getComparisonData()!)
    /* メイングラフ */
    const comparisonIntegrationTemperature: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonStemNumber: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonStemNumberM2: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonSpad: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonGrowthHeight: any[] = [null, null, null, null, null, null, null, null, null]
    /* 複合グラフ */
    const comparisonWaterLevel: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonWaterTemp: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonGroundTemp: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonPh: any[] = [null, null, null, null, null, null, null, null, null]
    /* 積算降水量 */
    const comparisonIntegratedPrecipitation: any[] = [null, null, null, null, null, null, null, null, null]
    /* 積算日射量 */
    const comparisonIntegratedInsolation: any[] = [null, null, null, null, null, null, null, null, null]
    /* 気温 */
    const comparisonTemperature: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureHighest: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureLowest: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonTemperatureDifference: any[] = [null, null, null, null, null, null, null, null, null]
    /* 日射量 */
    const comparisonSolarRadation: any[] = [null, null, null, null, null, null, null, null, null]
    /* 桿長・穂長 */
    const comparisonStemLength: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonEarLength: any[] = [null, null, null, null, null, null, null, null, null]
    /* NDVI */
    const comparisonNdvi: any[] = [null, null, null, null, null, null, null, null, null]

    for (var i in comparisonData) {
      /* メイングラフ */
      comparisonIntegrationTemperature.push(comparisonData[i].integration_temperature)
      comparisonStemNumber.push(comparisonData[i].stem_number)
      comparisonStemNumberM2.push(comparisonData[i].stem_number_m2)
      comparisonSpad.push(comparisonData[i].spad)
      comparisonGrowthHeight.push(comparisonData[i].growth_height)
      /* 複合グラフ */
      comparisonWaterLevel.push(comparisonData[i].water_level)
      comparisonWaterTemp.push(comparisonData[i].water_temp)
      comparisonGroundTemp.push(comparisonData[i].ground_temp)
      comparisonPh.push(comparisonData[i].ph)
      /* 積算降水量 */
      comparisonIntegratedPrecipitation.push(comparisonData[i].integrated_precipitation_amount)
      /* 積算日射量 */
      comparisonIntegratedInsolation.push(comparisonData[i].integrated_insolation)
      /* 気温 */
      comparisonTemperature.push(comparisonData[i].temperature)
      comparisonTemperatureHighest.push(comparisonData[i].temperature_highest)
      comparisonTemperatureLowest.push(comparisonData[i].temperature_lowest)
      comparisonTemperatureDifference.push(comparisonData[i].temperature_difference)
      /* 日射量 */
      comparisonSolarRadation.push(comparisonData[i].solar_radation)
      /* 桿長・穂長 */
      comparisonStemLength.push(comparisonData[i].stem_length)
      comparisonEarLength.push(comparisonData[i].ear_length)
      /* NDVI */
      comparisonNdvi.push(comparisonData[i].leaf_age)
    }

    /* データの書き換え */
    // メイングラフ
    this.chartData.datasets[1].data = comparisonIntegrationTemperature
    this.chartData.datasets[5].data = comparisonStemNumber
    this.chartData.datasets[8].data = comparisonStemNumberM2
    this.chartData.datasets[17].data = comparisonSpad
    this.chartData.datasets[26].data = comparisonGrowthHeight
    // 画像解析-茎数
    this.chartData.datasets[13].data = this.createCanonComparisonData('valid_stem_numbers', 'stem_number')
    this.chartData.datasets[14].data = this.createCanonComparisonData('temp_stem_numbers', 'stem_number')
    this.chartData.datasets[15].data = this.createCanonComparisonData('invalid_stem_numbers', 'stem_number')
    // 画像解析-葉色
    this.chartData.datasets[22].data = this.createCanonComparisonData('valid_spads', 'spad')
    this.chartData.datasets[23].data = this.createCanonComparisonData('temp_spads', 'spad')
    this.chartData.datasets[24].data = this.createCanonComparisonData('invalid_spads', 'spad')
    // 画像解析-草丈
    this.chartData.datasets[31].data = this.createCanonComparisonData('valid_plant_heights', 'plant_height')
    this.chartData.datasets[32].data = this.createCanonComparisonData('temp_plant_heights', 'plant_height')
    this.chartData.datasets[33].data = this.createCanonComparisonData('invalid_plant_heights', 'plant_height')

    // 複合グラフ
    this.areaChartData.datasets[1].data = comparisonWaterLevel
    this.areaChartData.datasets[4].data = comparisonWaterTemp
    this.areaChartData.datasets[7].data = comparisonGroundTemp
    this.areaChartData.datasets[10].data = comparisonPh

    // 積算降水量
    this.predictionChartData.datasets[1].data = comparisonIntegratedPrecipitation

    // 日射量
    this.solarRadationChartData.datasets[1].data = comparisonSolarRadation
    this.solarRadationChartData.datasets[1].pointRadius = this.judgePointRadius(comparisonSolarRadation)
    // 積算日射量
    this.solarRadationChartData.datasets[4].data = comparisonIntegratedInsolation
    this.solarRadationChartData.datasets[4].pointRadius = this.judgePointRadius(comparisonIntegratedInsolation)

    this.growthHightChartData.datasets[1].data = comparisonGrowthHeight
    this.growthHightChartData.datasets[3].data = comparisonStemLength
    this.growthHightChartData.datasets[5].data = comparisonEarLength
    // 気温
    this.temperatureChartData.datasets[1].data = comparisonTemperature
    this.temperatureChartData.datasets[3].data = comparisonTemperatureHighest
    this.temperatureChartData.datasets[5].data = comparisonTemperatureLowest
    this.temperatureDifferenceChartData.datasets[1].data = comparisonTemperatureDifference

    // NDVI
    this.ndviChartData.datasets[1].data = comparisonNdvi

    // 比例ダイアログの表示
    this.$store.commit('graphToggleState/setShowComparison', true)
    this.$store.commit('graphToggleState/setChangeComparisonGraph', false)
  }

  /* 比較データ */
  public changeComparisonGraph () {
    // 比較なしの場合は凡例をdisableに戻す
    if (this.$store.state.graphToggleState.hiddenComparisonData) {
      let legend1: any = document.getElementById('legend-1')
      let child: any = legend1.getElementsByTagName('li')
      child[1].classList.add('disabled')
      child[5].classList.add('disabled')
      child[8].classList.add('disabled')
      child[17].classList.add('disabled')
      child[26].classList.add('disabled')
      // 画像解析
      child[13].classList.add('disabled')
      child[22].classList.add('disabled')
      child[31].classList.add('disabled')

      let legend2: any = document.getElementById('legend-2')
      let areaChild: any = legend2.getElementsByTagName('li')
      areaChild[1].classList.add('disabled')
      areaChild[4].classList.add('disabled')
      areaChild[7].classList.add('disabled')
      areaChild[10].classList.add('disabled')

      let legend3: any = document.getElementById('legend-3')
      let predictionChild: any = legend3.getElementsByTagName('li')
      predictionChild[1].classList.add('disabled')

      let legend5: any = document.getElementById('legend-5')
      let solarRadationChild: any = legend5.getElementsByTagName('li')
      solarRadationChild[1].classList.add('disabled')
      solarRadationChild[4].classList.add('disabled')

      let legend6: any = document.getElementById('legend-6')
      let growthHightChild: any = legend6.getElementsByTagName('li')
      growthHightChild[1].classList.add('disabled')
      growthHightChild[3].classList.add('disabled')
      growthHightChild[5].classList.add('disabled')

      let legend7: any = document.getElementById('legend-7')
      let temperatureChild: any = legend7.getElementsByTagName('li')
      temperatureChild[1].classList.add('disabled')
      temperatureChild[3].classList.add('disabled')
      temperatureChild[5].classList.add('disabled')
      temperatureChild[7].classList.add('disabled')

      let legend8: any = document.getElementById('legend-8')
      let ndviChild: any = legend8.getElementsByTagName('li')
      ndviChild[1].classList.add('disabled')
    }

    // 再レンダリング
    this.updateAllGraph()
  }

  private updateAllGraph () {
    const graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }

    const areaGraph: any = this.$refs.areaGraph
    if (areaGraph !== undefined) {
      areaGraph.updateGraph()
    }

    const predictionGraph: any = this.$refs.predictionGraph
    if (predictionGraph !== undefined) {
      predictionGraph.updateGraph()
    }

    let solarRadationGraph: any = this.$refs.solarRadationGraph
    if (solarRadationGraph !== undefined) {
      solarRadationGraph.updateGraph()
    }

    let temperatureGraph: any = this.$refs.temperatureGraph
    if (temperatureGraph !== undefined) {
      temperatureGraph.updateGraph()
    }

    let temperatureDifferenceGraph: any = this.$refs.temperatureDifferenceGraph
    if (temperatureDifferenceGraph !== undefined) {
      temperatureDifferenceGraph.updateGraph()
    }

    let growthHightGraph: any = this.$refs.growthHightGraph
    if (growthHightGraph !== undefined) {
      growthHightGraph.updateGraph()
    }

    let ndviGraph: any = this.$refs.ndviGraph
    if (ndviGraph !== undefined) {
      ndviGraph.updateGraph()
    }

    this.isInit = false
    this.$emit('disable-loading')
  }

  private getCheckBoxs () {
    const settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null || settingData === undefined) {
      this.checkboxData = []
    } else {
      this.checkboxData = settingData.checkboxs
    }
  }

  /* 収穫適期の最短取得 */
  public getMinHarvestTime () {
    let harvestDate: Date
    if (JSON.parse(Session.getHarvestDetaisls()!).harvest_min_date) {
      let min = JSON.parse(Session.getHarvestDetaisls()!).harvest_min_date
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() - min)
    } else {
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() - 3)
    }
    return harvestDate
  }

  /* 収穫適期の最終取得 */
  public getMaxHarvestTime () {
    let harvestDate: Date
    if (JSON.parse(Session.getHarvestDetaisls()!).harvest_max_date) {
      let max = JSON.parse(Session.getHarvestDetaisls()!).harvest_max_date
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() + max)
    } else {
      harvestDate = DateClass.formingDate(Session.getHarvestTime()!)
      harvestDate.setDate(harvestDate.getDate() + 3)
    }
    return harvestDate
  }

  /* ステージバーの日付 */
  public createStageBar (growthStageList: any[]) {
    const growthDateList: any[] = []
    const setGraphDialogData: any = this.setGraphDialogData

    // ステージデータがない場合はステージバーを作らない
    if (growthStageList === null || (growthStageList.length === 1 && growthStageList[0].id === 0)) {
      return
    }
    const lastDate = this.label[this.label.length - 1]
    for (var i in growthStageList) {
      let targetDay = DateClass.formingDate(Session.getPlantingDay()!)
      targetDay.setDate(targetDay.getDate() + growthStageList[i].elapsed_days)
      if (targetDay < this.graphRange[0] || targetDay > this.graphRange[1]) {
        growthDateList.push(null)
      } else {
        growthDateList.push(targetDay)
      }
    }

    for (var j = 0; j < growthDateList.length; j++) {
      if (!growthDateList[j]) {
        continue
      }

      let stageLine = {}
      let harvestTime = {}
      let stageLabel = {}
      let dateLabel = {}

      /* 線のみ描画 */
      stageLine = {
        drawTime: 'beforeDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        id: 'barLine/' + growthStageList[j].growth_step,
        scaleID: 'x-axis-0',
        value: growthDateList[j],
        borderColor: '#D1D1D1',
        borderWidth: 2
      }
      this.chartOptions.annotation.annotations.push(stageLine)

      /* ラベルのみ描画 */
      const yAdjust = j % 2 === 0 ? 0 : 52
      stageLabel = {
        drawTime: 'afterDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        id: 'bar/' + growthStageList[j].growth_step,
        scaleID: 'x-axis-0',
        value: growthDateList[j],
        borderColor: this.transparentColor,
        borderWidth: 2,
        label: {
          backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
          fontSize: 11,
          fontColor: '#333',
          content: growthStageList[j].growth_stage_name,
          fontStyle: 'bold',
          enabled: true,
          xPadding: 13,
          yPadding: 8,
          yAdjust: 8 + yAdjust,
          position: 'top'
        },
        onMouseover: function (event: any) {
          setGraphDialogData(this, event, false)
        },
        onMouseleave: this.closeGraphDialog,
        onClick: this.changeStageDate
      }
      dateLabel = {
        drawTime: 'afterDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        id: 'label/' + growthStageList[j].growth_step,
        scaleID: 'x-axis-0',
        value: growthDateList[j],
        borderColor: this.transparentColor,
        borderWidth: 2,
        label: {
          backgroundColor: this.showStageDate ? this.changeStageBg(growthStageList[j].growth_stage_histories) : this.transparentColor,
          fontSize: 11,
          fontColor: this.showStageDate ? '#333' : this.transparentColor,
          content: this.createLabel(growthStageList[j]),
          fontStyle: 'bold',
          enabled: true,
          xPadding: 8,
          yPadding: 7,
          yAdjust: 34 + yAdjust,
          position: 'top'
        },
        onMouseover: function (event: any) {
          setGraphDialogData(this, event, false)
        },
        onMouseleave: this.closeGraphDialog
      }

      this.chartOptions.annotation.annotations.push(stageLabel)
      this.chartOptions.annotation.annotations.push(dateLabel)
    }

    // 収穫適期範囲
    const hargestRange = [DateClass.max(this.label[0], this.getMinHarvestTime()), DateClass.min(this.label.slice(-1)[0], this.getMaxHarvestTime())]
    if (DateClass.daysCalculation(DateClass.dateToInt(hargestRange[0]), DateClass.dateToInt(hargestRange[1])) >= 1) {
      let harvestTime = {
        drawTime: 'beforeDatasetsDraw',
        type: 'box',
        xScaleID: 'x-axis-0',
        yScaleID: 'yAxis_2',
        xMin: hargestRange[0],
        xMax: hargestRange[1],
        yMin: 0,
        yMax: 200,
        backgroundColor: 'rgba(193,193,193, .2)',
        borderColor: 'rgba(193,193,193, .2)'
      }
      this.chartOptions.annotation.annotations.push(harvestTime)
    }

    // 中干し予測データ作成
    this.createMidsummerDrainageData()
  }

  private createMidsummerDrainageData () {
    const setGraphDialogData: any = this.setGraphDialogData
    const midsummerDrainage = JSON.parse(Session.getMidsummerDrainage()!)
    if (!midsummerDrainage) {
      this.showMidDrainageModalBtn = false
      return
    } else {
      switch (Number(Local.getUserType())) {
        case userType.USER_TYPE_VIEWER:
        case userType.USER_TYPE_ALL_VIEWER:
          break
        default:
          this.showMidDrainageModalBtn = true
          this.setMidDrainageBtnRight()
      }
    }

    const params = midsummerDrainage.start_date && midsummerDrainage.end_date ? {
      startDate: midsummerDrainage.start_date,
      endDate: midsummerDrainage.end_date,
      color: 'rgba(255, 195, 150, 0.5)'
    } : {
      startDate: midsummerDrainage.goal_start_date,
      endDate: midsummerDrainage.goal_end_date,
      color: 'rgba(160, 230, 242, 0.5)'
    }
    const midDrainRange = [DateClass.max(this.label[0], new Date(params.startDate)), DateClass.min(this.label.slice(-1)[0], new Date(params.endDate))]
    if (DateClass.daysCalculation(DateClass.dateToInt(midDrainRange[0]), DateClass.dateToInt(midDrainRange[1])) >= 1) {
      const boxAnnotation = {
        type: 'box',
        drawTime: 'beforeDatasetsDraw',
        xScaleID: 'x-axis-0',
        yScaleID: 'y-axis-0',
        xMin: midDrainRange[0],
        xMax: midDrainRange[1],
        yMin: 0,
        yMax: 200,
        backgroundColor: params.color,
        onMouseover: function (event: any) {
          setGraphDialogData(this, event, true)
        },
        onMouseleave: this.closeGraphDialog
      }
      this.chartOptions.annotation.annotations.splice(0, 0, boxAnnotation)
    }
  }

  private changeStageBg (val: any[]) {
    if (val === undefined || val.length === 0) {
      return 'rgba(193,193,193,0.5)'
    } else {
      return 'rgba(247,215,30,0.7)'
    }
  }

  private createLabel (data: any) {
    if (Session.getPlantingDay()! === null) {
      return
    }
    let content: string
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (data.elapsed_days * 24 * 60 * 60 * 1000))

    content = DateClass.toDoubleDigits(newDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(newDate.getDate())
    return content
  }

  /* ステージバーをクリックしたときの処理 */
  public changeStageDate (event: any) {
    this.showDetailsDialog = false
    let growthData = Vue.prototype.$globalGrowthData
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (growthData.elapsed_days * 24 * 60 * 60 * 1000))
    let date = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
    let today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    const userTypeId = parseInt(Local.getUserType()!)
    // 閲覧者(user_type_id=5)と全圃場閲覧者(user_type_id=6)は変更不可のためモーダル表示しない
    // 播種日と今日より先は変更不可
    if (userTypeId !== userType.USER_TYPE_VIEWER && userTypeId !== userType.USER_TYPE_ALL_VIEWER && growthData.growth_step !== 1 && date <= today) {
      this.$store.commit('stageUpdateState/setChangeId', parseInt(growthData.growth_stage_id))
      this.showStageUpdateModal = true
    }
  }

  public closeStageUpdateModal () {
    this.showStageUpdateModal = false
  }

  /* ステージバーの更新処理 */
  private reacquireStage () {
    this.$emit('reacquire-stage-data')
  }

  private showErrorAlert (msg: string) {
    this.$emit('show-error-alert', msg)
  }

  private showError409Modal () {
    this.$emit('show-error409-modal')
  }

  /* スライドバー移動処理 */
  public changeDate (e: any) {
    let date = this.label[this.slide]
    let keyDate = parseInt('' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate()))

    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  public overWriteDate (e: any) {
    let date = e.subject.config.value._d
    let keyDate = parseInt('' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate()))
    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  private setGraphDialogData (data: any, event: any, isMidDrain: boolean) {
    this.isMidDrain = isMidDrain
    if (isMidDrain) {
      CommonClass.setMidsummerDrainageData(data, event)
    } else {
      CommonClass.setGrowthData(data, event)
    }
  }

  /* グラフのダイアログを表示 */
  public showGraphDialog () {
    if (!this.showDetailsDialog) {
      this.growthData = Vue.prototype.$globalGrowthData
      this.$store.commit('setFlagState/setGraphDialogFlag', true)
      // ポジション
      this.dialogLeft = (Vue.prototype.$globalElX - 50) + 'px'
      if (this.isMidDrain) {
        this.dialogTop = '205px'
      } else {
        let growthStageList = JSON.parse(Session.getGrowthStage()!)
        for (let i in growthStageList) {
          if (growthStageList[i].growth_step === this.growthData.growth_step) {
            let num = parseInt(i) % 2
            if (num === 0) {
              this.dialogTop = '105px'
            } else {
              this.dialogTop = '155px'
            }
            break
          }
        }
      }
      this.toggleDialog()
    } else {
      this.toggleDialog()
    }
  }

  public toggleDialog () {
    if (this.showDetailsDialog) {
      this.showDetailsDialog = false
    } else {
      this.showDetailsDialog = true
    }
  }

  public closeGraphDialog ($event: any) {
    $event.preventDefault()
    this.showDetailsDialog = false
  }

  /* グラフ表示切り替え */
  public displayGraph () {
    this.createComparisonData()
    let legend1: any = document.getElementById('legend-1')
    let child: any = legend1.getElementsByTagName('li')

    let legend2: any = document.getElementById('legend-2')
    let child2: any = legend2.getElementsByTagName('li')

    let legend3: any = document.getElementById('legend-3')
    let child3: any = legend3.getElementsByTagName('li')

    let legend5: any = document.getElementById('legend-5')
    let child5: any = legend5.getElementsByTagName('li')

    let legend6: any = document.getElementById('legend-6')
    let child6: any = legend6.getElementsByTagName('li')

    let legend7: any = document.getElementById('legend-7')
    let child7: any = legend7.getElementsByTagName('li')

    let legend8: any = document.getElementById('legend-8')
    let child8: any = legend8.getElementsByTagName('li')

    // グラフの凡例ができているか確認
    if (child.length === 0 || child2.length === 0 || child3.length === 0 || child5.length === 0 || child6.length === 0 || child7.length === 0 || child8.length === 0) {
      setTimeout(this.displayGraph, 200)
      return
    }

    const type = Session.getStemNumberType()!

    this.getCheckBoxs()
    let data
    if (this.checkboxData.length === 0) {
      data = [
        { label: '積算温度', value: 'integrationTemperature', checked: true, display: true },
        { label: '茎数(株)', value: 'stemNumber', checked: true, display: true },
        { label: '茎数(平米)', value: 'stemNumberM2', checked: true, display: true },
        { label: '草丈', value: 'growthHeight', checked: true, display: true },
        { label: '葉色値', value: 'spad', checked: true, display: true },
        { label: '画像解析-茎数(株)', value: 'imageAnalysisStemNumber', checked: true, display: true },
        { label: '画像解析-葉色', value: 'imageAnalysisSpad', checked: true, display: true },
        { label: '画像解析-草丈', value: 'imageAnalysisGrowthHeight', checked: true, display: true },
        { label: '桿長', value: 'stemLength', checked: true, display: true },
        { label: '穂長', value: 'earLength', checked: true, display: true },
        { label: '日平均気温', value: 'temperature', checked: false, display: true },
        { label: '最高気温', value: 'temperatureHighest', checked: false, display: true },
        { label: '最低気温', value: 'temperatureLowest', checked: false, display: true },
        { label: '寒暖差', value: 'temperatureDifference', checked: false, display: true },
        { label: '日射量', value: 'solarRadation', checked: false, display: true },
        { label: '積算日射量', value: 'integratedInsolation', checked: false, display: true },
        { label: '', value: '', checked: false, display: true },
        { label: '積算降水量', value: 'soilStatus', checked: false, display: true },
        { label: '水位', value: 'waterLevel', checked: true, display: true },
        { label: '水温', value: 'waterTemp', checked: true, display: true },
        { label: '地温', value: 'groundTemp', checked: true, display: true },
        { label: 'pH', value: 'ph', checked: false, display: true },
        { label: 'NDVI', value: 'leafAge', checked: true, display: true }
      ]
    } else {
      data = this.checkboxData
    }

    for (var i in data) {
      if (data[i].label === '積算温度') {
        if (!data[i].checked) {
          this.chartData.datasets[0].hidden = true
          this.chartData.datasets[1].hidden = true
          this.chartData.datasets[2].hidden = true
          this.chartData.datasets[3].hidden = true
          // 凡例書き換え
          child[0].classList.add('hidden')
          child[1].classList.add('hidden')
          child[2].classList.add('hidden')
          child[3].classList.add('hidden')
        } else {
          this.chartData.datasets[0].hidden = false
          this.chartData.datasets[1].hidden = false
          this.chartData.datasets[2].hidden = false
          this.chartData.datasets[3].hidden = false
          // 凡例書き換え
          child[0].classList.remove('hidden')
          child[1].classList.remove('hidden')
          child[2].classList.remove('hidden')
          child[3].classList.remove('hidden')
        }
      }

      if (data[i].label === '茎数(株)') {
        if (type === '2' || !data[i].checked) {
          this.chartData.datasets[4].hidden = true
          this.chartData.datasets[5].hidden = true
          this.chartData.datasets[6].hidden = true
          // 凡例書き換え
          child[4].classList.add('hidden')
          child[5].classList.add('hidden')
          child[6].classList.add('hidden')
        } else {
          this.chartData.datasets[4].hidden = false
          this.chartData.datasets[5].hidden = false
          this.chartData.datasets[6].hidden = false
          // 凡例書き換え
          child[4].classList.remove('hidden')
          child[5].classList.remove('hidden')
          child[6].classList.remove('hidden')
        }
      }

      if (data[i].label === '茎数(平米)') {
        if (type === '1' || !data[i].checked) {
          this.chartData.datasets[7].hidden = true
          this.chartData.datasets[8].hidden = true
          this.chartData.datasets[9].hidden = true
          // 凡例書き換え
          child[7].classList.add('hidden')
          child[8].classList.add('hidden')
          child[9].classList.add('hidden')
        } else {
          this.chartData.datasets[7].hidden = false
          this.chartData.datasets[8].hidden = false
          this.chartData.datasets[9].hidden = false
          // 凡例書き換え
          child[7].classList.remove('hidden')
          child[8].classList.remove('hidden')
          child[9].classList.remove('hidden')
        }
      }

      if (data[i].label === '画像解析-茎数(株)') {
        if (type === '2' || !data[i].checked) {
          this.chartData.datasets[10].hidden = true
          this.chartData.datasets[11].hidden = true
          this.chartData.datasets[12].hidden = true
          this.chartData.datasets[13].hidden = true
          this.chartData.datasets[14].hidden = true
          this.chartData.datasets[15].hidden = true
          // 凡例書き換え
          child[10].classList.add('hidden')
          child[13].classList.add('hidden')
        } else {
          this.chartData.datasets[10].hidden = false
          this.chartData.datasets[11].hidden = false
          this.chartData.datasets[12].hidden = false
          this.chartData.datasets[13].hidden = false
          this.chartData.datasets[14].hidden = false
          this.chartData.datasets[15].hidden = false
          // 凡例書き換え
          child[10].classList.remove('hidden')
          child[13].classList.remove('hidden')
        }
      }

      if (data[i].label === '葉色値') {
        if (!data[i].checked) {
          this.chartData.datasets[16].hidden = true
          this.chartData.datasets[17].hidden = true
          this.chartData.datasets[18].hidden = true
          // 凡例書き換え
          child[16].classList.add('hidden')
          child[17].classList.add('hidden')
          child[18].classList.add('hidden')
        } else {
          this.chartData.datasets[16].hidden = false
          this.chartData.datasets[17].hidden = false
          this.chartData.datasets[18].hidden = false
          // 凡例書き換え
          child[16].classList.remove('hidden')
          child[17].classList.remove('hidden')
          child[18].classList.remove('hidden')
        }
      }

      if (data[i].label === '画像解析-葉色') {
        if (!data[i].checked) {
          this.chartData.datasets[19].hidden = true
          this.chartData.datasets[20].hidden = true
          this.chartData.datasets[21].hidden = true
          this.chartData.datasets[22].hidden = true
          this.chartData.datasets[23].hidden = true
          this.chartData.datasets[24].hidden = true
          // 凡例書き換え
          child[19].classList.add('hidden')
          child[22].classList.add('hidden')
        } else {
          this.chartData.datasets[19].hidden = false
          this.chartData.datasets[20].hidden = false
          this.chartData.datasets[21].hidden = false
          this.chartData.datasets[22].hidden = false
          this.chartData.datasets[23].hidden = false
          this.chartData.datasets[24].hidden = false
          // 凡例書き換え
          child[19].classList.remove('hidden')
          child[22].classList.remove('hidden')
        }
      }

      if (data[i].label === '草丈') {
        if (!data[i].checked) {
          this.chartData.datasets[25].hidden = true
          this.chartData.datasets[26].hidden = true
          this.chartData.datasets[27].hidden = true
          // 凡例書き換え
          child[25].classList.add('hidden')
          child[26].classList.add('hidden')
          child[27].classList.add('hidden')
        } else {
          this.chartData.datasets[25].hidden = false
          this.chartData.datasets[26].hidden = false
          this.chartData.datasets[27].hidden = false
          // 凡例書き換え
          child[25].classList.remove('hidden')
          child[26].classList.remove('hidden')
          child[27].classList.remove('hidden')
        }
      }

      if (data[i].label === '画像解析-草丈') {
        if (!data[i].checked) {
          this.chartData.datasets[28].hidden = true
          this.chartData.datasets[29].hidden = true
          this.chartData.datasets[30].hidden = true
          this.chartData.datasets[31].hidden = true
          this.chartData.datasets[32].hidden = true
          this.chartData.datasets[33].hidden = true
          // 凡例書き換え
          child[28].classList.add('hidden')
          child[31].classList.add('hidden')
        } else {
          this.chartData.datasets[28].hidden = false
          this.chartData.datasets[29].hidden = false
          this.chartData.datasets[30].hidden = false
          this.chartData.datasets[31].hidden = false
          this.chartData.datasets[32].hidden = false
          this.chartData.datasets[33].hidden = false
          // 凡例書き換え
          child[28].classList.remove('hidden')
          child[31].classList.remove('hidden')
        }
      }

      if (data[i].label === '水位') {
        if (!data[i].checked) {
          this.areaChartData.datasets[0].hidden = true
          this.areaChartData.datasets[1].hidden = true
          this.areaChartData.datasets[2].hidden = true
          // 凡例書き換え
          child2[0].classList.add('hidden')
          child2[1].classList.add('hidden')
          child2[2].classList.add('hidden')
          this.showAreaChart = false
        } else {
          this.areaChartData.datasets[0].hidden = false
          this.areaChartData.datasets[1].hidden = false
          this.areaChartData.datasets[2].hidden = false
          // 凡例書き換え
          child2[0].classList.remove('hidden')
          child2[1].classList.remove('hidden')
          child2[2].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === '水温') {
        if (!data[i].checked) {
          this.areaChartData.datasets[3].hidden = true
          this.areaChartData.datasets[4].hidden = true
          this.areaChartData.datasets[5].hidden = true
          // 凡例書き換え
          child2[3].classList.add('hidden')
          child2[4].classList.add('hidden')
          child2[5].classList.add('hidden')
        } else {
          this.areaChartData.datasets[3].hidden = false
          this.areaChartData.datasets[4].hidden = false
          this.areaChartData.datasets[5].hidden = false
          // 凡例書き換え
          child2[3].classList.remove('hidden')
          child2[4].classList.remove('hidden')
          child2[5].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === '地温') {
        if (!data[i].checked) {
          this.areaChartData.datasets[6].hidden = true
          this.areaChartData.datasets[7].hidden = true
          this.areaChartData.datasets[8].hidden = true
          // 凡例書き換え
          child2[6].classList.add('hidden')
          child2[7].classList.add('hidden')
          child2[8].classList.add('hidden')
        } else {
          this.areaChartData.datasets[6].hidden = false
          this.areaChartData.datasets[7].hidden = false
          this.areaChartData.datasets[8].hidden = false
          // 凡例書き換え
          child2[6].classList.remove('hidden')
          child2[7].classList.remove('hidden')
          child2[8].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === 'pH') {
        if (!data[i].checked) {
          this.areaChartData.datasets[9].hidden = true
          this.areaChartData.datasets[10].hidden = true
          this.areaChartData.datasets[11].hidden = true
          // 凡例書き換え
          child2[9].classList.add('hidden')
          child2[10].classList.add('hidden')
          child2[11].classList.add('hidden')
        } else {
          this.areaChartData.datasets[9].hidden = false
          this.areaChartData.datasets[10].hidden = false
          this.areaChartData.datasets[11].hidden = false
          // 凡例書き換え
          child2[9].classList.remove('hidden')
          child2[10].classList.remove('hidden')
          child2[11].classList.remove('hidden')
          this.showAreaChart = true
        }
      }

      if (data[i].label === '積算降水量') {
        if (!data[i].checked) {
          this.showTemparatureChart = false
        } else {
          this.showTemparatureChart = true
          this.predictionChartData.datasets[0].hidden = false
          this.predictionChartData.datasets[1].hidden = false
          this.predictionChartData.datasets[2].hidden = false
          child3[0].classList.remove('hidden')
          child3[1].classList.remove('hidden')
          child3[2].classList.remove('hidden')
        }
      }

      if (data[i].label === '桿長') {
        if (!data[i].checked) {
          this.growthHightChartData.datasets[2].hidden = true
          this.growthHightChartData.datasets[3].hidden = true
          child6[2].classList.add('hidden')
          child6[3].classList.add('hidden')
          this.showGrowthHightChart = false
        } else {
          this.growthHightChartData.datasets[2].hidden = false
          this.growthHightChartData.datasets[3].hidden = false
          child6[2].classList.remove('hidden')
          child6[3].classList.remove('hidden')
          this.showGrowthHightChart = true
        }
      }

      if (data[i].label === '穂長') {
        if (!data[i].checked) {
          this.growthHightChartData.datasets[4].hidden = true
          this.growthHightChartData.datasets[5].hidden = true
          child6[4].classList.add('hidden')
          child6[5].classList.add('hidden')
        } else {
          this.growthHightChartData.datasets[4].hidden = false
          this.growthHightChartData.datasets[5].hidden = false
          child6[4].classList.remove('hidden')
          child6[5].classList.remove('hidden')
          this.showGrowthHightChart = true
        }
      }

      // 桿長・穂長グラフの草丈
      if (this.showGrowthHightChart) {
        this.growthHightChartData.datasets[0].hidden = false
        this.growthHightChartData.datasets[1].hidden = false
        child6[0].classList.remove('hidden')
        child6[1].classList.remove('hidden')
      }

      if (data[i].label === '日射量') {
        if (!data[i].checked) {
          this.solarRadationChartData.datasets[0].hidden = true
          this.solarRadationChartData.datasets[1].hidden = true
          this.solarRadationChartData.datasets[2].hidden = true
          child5[0].classList.add('hidden')
          child5[1].classList.add('hidden')
          child5[2].classList.add('hidden')
          this.showSolarRadationChart = false
        } else {
          this.solarRadationChartData.datasets[0].hidden = false
          this.solarRadationChartData.datasets[1].hidden = false
          this.solarRadationChartData.datasets[2].hidden = false
          child5[0].classList.remove('hidden')
          child5[1].classList.remove('hidden')
          child5[2].classList.remove('hidden')
          this.showSolarRadationChart = true
        }
      }

      if (data[i].label === '積算日射量') {
        if (!data[i].checked) {
          this.solarRadationChartData.datasets[3].hidden = true
          this.solarRadationChartData.datasets[4].hidden = true
          this.solarRadationChartData.datasets[5].hidden = true
          child5[3].classList.add('hidden')
          child5[4].classList.add('hidden')
          child5[5].classList.add('hidden')
        } else {
          this.solarRadationChartData.datasets[3].hidden = false
          this.solarRadationChartData.datasets[4].hidden = false
          this.solarRadationChartData.datasets[5].hidden = false
          child5[3].classList.remove('hidden')
          child5[4].classList.remove('hidden')
          child5[5].classList.remove('hidden')
          this.showSolarRadationChart = true
        }
      }

      if (data[i].label === '日平均気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[0].hidden = true
          this.temperatureChartData.datasets[1].hidden = true
          child7[0].classList.add('hidden')
          child7[1].classList.add('hidden')
          this.showTemperatureChart = false
        } else {
          this.temperatureChartData.datasets[0].hidden = false
          this.temperatureChartData.datasets[1].hidden = false
          child7[0].classList.remove('hidden')
          child7[1].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '最高気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[2].hidden = true
          this.temperatureChartData.datasets[3].hidden = true
          child7[2].classList.add('hidden')
          child7[3].classList.add('hidden')
        } else {
          this.temperatureChartData.datasets[2].hidden = false
          this.temperatureChartData.datasets[3].hidden = false
          child7[2].classList.remove('hidden')
          child7[3].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '最低気温') {
        if (!data[i].checked) {
          this.temperatureChartData.datasets[4].hidden = true
          this.temperatureChartData.datasets[5].hidden = true
          child7[4].classList.add('hidden')
          child7[5].classList.add('hidden')
        } else {
          this.temperatureChartData.datasets[4].hidden = false
          this.temperatureChartData.datasets[5].hidden = false
          child7[4].classList.remove('hidden')
          child7[5].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === '寒暖差') {
        if (!data[i].checked) {
          this.temperatureDifferenceChartData.datasets[0].hidden = true
          this.temperatureDifferenceChartData.datasets[1].hidden = true
          child7[6].classList.add('hidden')
          child7[7].classList.add('hidden')
        } else {
          this.temperatureDifferenceChartData.datasets[0].hidden = false
          this.temperatureDifferenceChartData.datasets[1].hidden = false
          child7[6].classList.remove('hidden')
          child7[7].classList.remove('hidden')
          this.showTemperatureChart = true
        }
      }

      if (data[i].label === 'NDVI') {
        if (!data[i].checked) {
          this.ndviChartData.datasets[0].hidden = true
          this.ndviChartData.datasets[1].hidden = true
          // 凡例書き換え
          child8[0].classList.add('hidden')
          child8[1].classList.add('hidden')
          this.showNdviChart = false
        } else {
          this.ndviChartData.datasets[0].hidden = false
          this.ndviChartData.datasets[1].hidden = false
          // 凡例書き換え
          child8[0].classList.remove('hidden')
          child8[1].classList.remove('hidden')
          this.showNdviChart = true
        }
      }
    }

    // 比較系
    if (!this.$store.state.graphToggleState.hiddenComparisonData) {
      child[1].classList.remove('disabled')
      child[5].classList.remove('disabled')
      child[8].classList.remove('disabled')
      child[13].classList.remove('disabled')
      child[17].classList.remove('disabled')
      child[22].classList.remove('disabled')
      child[26].classList.remove('disabled')
      child[31].classList.remove('disabled')
      child2[1].classList.remove('disabled')
      child2[4].classList.remove('disabled')
      child2[7].classList.remove('disabled')
      child2[10].classList.remove('disabled')
      child3[1].classList.remove('disabled')
      child5[1].classList.remove('disabled')
      child5[4].classList.remove('disabled')
      child6[1].classList.remove('disabled')
      child6[3].classList.remove('disabled')
      child6[5].classList.remove('disabled')
      child7[1].classList.remove('disabled')
      child7[3].classList.remove('disabled')
      child7[5].classList.remove('disabled')
      child7[7].classList.remove('disabled')
      child8[1].classList.remove('disabled')
    } else {
      child[1].classList.add('disabled')
      child[5].classList.add('disabled')
      child[8].classList.add('disabled')
      child[13].classList.add('disabled')
      child[17].classList.add('disabled')
      child[22].classList.add('disabled')
      child[26].classList.add('disabled')
      child[31].classList.add('disabled')
      child2[1].classList.add('disabled')
      child2[4].classList.add('disabled')
      child2[7].classList.add('disabled')
      child2[10].classList.add('disabled')
      child3[1].classList.add('disabled')
      child5[1].classList.add('disabled')
      child5[4].classList.add('disabled')
      child6[1].classList.add('disabled')
      child6[3].classList.add('disabled')
      child6[5].classList.add('disabled')
      child7[1].classList.add('disabled')
      child7[3].classList.add('disabled')
      child7[5].classList.add('disabled')
      child7[7].classList.add('disabled')
      child8[1].classList.add('disabled')
      this.chartData.datasets[1].hidden = true
      this.chartData.datasets[5].hidden = true
      this.chartData.datasets[8].hidden = true
      this.chartData.datasets[13].hidden = true
      this.chartData.datasets[14].hidden = true
      this.chartData.datasets[15].hidden = true
      this.chartData.datasets[17].hidden = true
      this.chartData.datasets[22].hidden = true
      this.chartData.datasets[23].hidden = true
      this.chartData.datasets[24].hidden = true
      this.chartData.datasets[26].hidden = true
      this.chartData.datasets[31].hidden = true
      this.chartData.datasets[32].hidden = true
      this.chartData.datasets[33].hidden = true
      this.areaChartData.datasets[1].hidden = true
      this.areaChartData.datasets[4].hidden = true
      this.areaChartData.datasets[7].hidden = true
      this.areaChartData.datasets[10].hidden = true
      this.predictionChartData.datasets[1].hidden = true
      this.solarRadationChartData.datasets[1].hidden = true
      this.solarRadationChartData.datasets[4].hidden = true
      this.temperatureChartData.datasets[1].hidden = true
      this.temperatureChartData.datasets[3].hidden = true
      this.temperatureChartData.datasets[5].hidden = true
      this.temperatureDifferenceChartData.datasets[1].hidden = true
      this.growthHightChartData.datasets[1].hidden = true
      this.growthHightChartData.datasets[3].hidden = true
      this.growthHightChartData.datasets[5].hidden = true
      this.ndviChartData.datasets[1].hidden = true
    }

    // 再レンダリング
    this.updateAllGraph()
  }

  public displayLegend () {
    let myLegend: any = document.getElementById('legend-1')
    let legendItems: any = myLegend.getElementsByTagName('li')
    for (var i = 0; i < legendItems.length; i += 1) {
      legendItems[i].addEventListener('click', this.legendClickEvents, false)
    }
  }

  public displayAreaLegend () {
    let myLegend2: any = document.getElementById('legend-2')
    let legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.areaLegendClickEvents, false)
    }
  }

  public displayTemparatureLegend () {
    let myLegend2: any = document.getElementById('legend-3')
    let legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.predictionClickEvents, false)
    }
  }

  public displaySolarRadationLegend () {
    let myLegend: any = document.getElementById('legend-5')
    let legendItems: any = myLegend.getElementsByTagName('li')

    for (var j = 0; j < legendItems.length; j += 1) {
      legendItems[j].addEventListener('click', this.solarRadationClickEvents, false)
    }
  }

  public displayTemperatureLegend () {
    let myLegend: any = document.getElementById('legend-7')
    let legendItems: any = myLegend.getElementsByTagName('li')

    for (var j = 0; j < legendItems.length; j += 1) {
      legendItems[j].addEventListener('click', this.temperatureClickEvents, false)
    }
  }

  public displaygrowthHightLegend () {
    let myLegend: any = document.getElementById('legend-6')
    let legendItems: any = myLegend.getElementsByTagName('li')

    for (var j = 0; j < legendItems.length; j += 1) {
      legendItems[j].addEventListener('click', this.growthHightClickEvents, false)
    }
  }

  public displayNdviLegend () {
    let myLegend: any = document.getElementById('legend-8')
    let legendItems: any = myLegend.getElementsByTagName('li')

    for (var j = 0; j < legendItems.length; j += 1) {
      legendItems[j].addEventListener('click', this.ndviClickEvents, false)
    }
  }

  public legendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.chartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.chartData.datasets[index].hidden === null || this.chartData.datasets[index].hidden === false) {
      this.chartData.datasets[index].hidden = true
      // canon(画像解析)グラフはグラフ3つに対し凡例は1つのため以下で表示切替
      if (index === 10 ||
          index === 13 ||
          index === 19 ||
          index === 22 ||
          index === 28 ||
          index === 31) {
        for (let i = index + 1; i <= index + 2; i++) {
          this.chartData.datasets[i].hidden = true
        }
      }
      target.classList.add('hidden')
    } else {
      this.chartData.datasets[index].hidden = false
      // canon(画像解析)グラフはグラフ3つに対し凡例は1つのため以下で表示切替
      if (index === 10 ||
          index === 13 ||
          index === 19 ||
          index === 22 ||
          index === 28 ||
          index === 31) {
        for (let i = index + 1; i <= index + 2; i++) {
          this.chartData.datasets[i].hidden = false
        }
      }
      target.classList.remove('hidden')
    }

    let graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  public areaLegendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.areaChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.areaChartData.datasets[index].hidden === null || this.areaChartData.datasets[index].hidden === false) {
      this.areaChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.areaChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setAreaScaleYPadding()

    let areaGraph: any = this.$refs.areaGraph
    if (areaGraph !== undefined) {
      areaGraph.updateGraph(this.areaChartOptions)
    }
  }

  public predictionClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.predictionChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.predictionChartData.datasets[index].hidden === null || this.predictionChartData.datasets[index].hidden === false) {
      this.predictionChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.predictionChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setPredictionScaleYPadding()

    let predictionGraph: any = this.$refs.predictionGraph
    if (predictionGraph !== undefined) {
      predictionGraph.updateGraph()
    }
  }

  public growthHightClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.growthHightChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.growthHightChartData.datasets[index].hidden === null || this.growthHightChartData.datasets[index].hidden === false) {
      this.growthHightChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.growthHightChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let graph: any = this.$refs.growthHightGraph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  public ndviClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.ndviChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.ndviChartData.datasets[index].hidden === null || this.ndviChartData.datasets[index].hidden === false) {
      this.ndviChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.ndviChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let graph: any = this.$refs.ndviGraph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  public solarRadationClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.solarRadationChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.solarRadationChartData.datasets[index].hidden === null || this.solarRadationChartData.datasets[index].hidden === false) {
      this.solarRadationChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.solarRadationChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setSolarRadationScaleYPadding()

    let solarRadationGraph: any = this.$refs.solarRadationGraph
    if (solarRadationGraph !== undefined) {
      solarRadationGraph.updateGraph()
    }
  }

  public temperatureClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.temperatureChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (index === 6 || index === 7) {
      let temperatureDifferenceIndex = 0
      if (index === 7) {
        temperatureDifferenceIndex = 1
      }
      if (this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden === null || this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden === false) {
        this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden = true
        target.classList.add('hidden')
      } else {
        this.temperatureDifferenceChartData.datasets[temperatureDifferenceIndex].hidden = false
        target.classList.remove('hidden')
      }

      this.setTemperatureDifferenceScaleYPadding()

      let temperatureDifferenceGraph: any = this.$refs.temperatureDifferenceGraph
      if (temperatureDifferenceGraph !== undefined) {
        temperatureDifferenceGraph.updateGraph()
      }
    } else {
      if (this.temperatureChartData.datasets[index].hidden === null || this.temperatureChartData.datasets[index].hidden === false) {
        this.temperatureChartData.datasets[index].hidden = true
        target.classList.add('hidden')
      } else {
        this.temperatureChartData.datasets[index].hidden = false
        target.classList.remove('hidden')
      }

      this.setTemperatureScaleYPadding()

      let temperatureGraph: any = this.$refs.temperatureGraph
      if (temperatureGraph !== undefined) {
        temperatureGraph.updateGraph()
      }
    }
  }

  public temperatureDifferenceClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    let index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.temperatureDifferenceChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.temperatureDifferenceChartData.datasets[index].hidden === null || this.temperatureDifferenceChartData.datasets[index].hidden === false) {
      this.temperatureDifferenceChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.temperatureDifferenceChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    this.setTemperatureDifferenceScaleYPadding()

    let temperatureDifferenceGraph: any = this.$refs.temperatureDifferenceGraph
    if (temperatureDifferenceGraph !== undefined) {
      temperatureDifferenceGraph.updateGraph()
    }
  }

  private setAreaScaleYPadding () {
    let scaleMax = 10 // 目盛り初期値
    let tmpMax = 0
    let areaChartData = this.areaChartData.datasets
    for (let chartData of areaChartData) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }
      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.areaChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setPredictionScaleYPadding () {
    let scaleMax = 1000 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.predictionChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }
      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.precipitationChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setSolarRadationScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.solarRadationChartData.datasets) {
      if (chartData.hidden || chartData.yAxisID === 'yAxis_2') {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }

      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.solarRadationChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private setTemperatureScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.temperatureChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }

      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.temperatureChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length, 'temperature')
  }

  private setTemperatureDifferenceScaleYPadding () {
    let scaleMax = 40 // 目盛り初期値
    let tmpMax = 0
    for (let chartData of this.temperatureDifferenceChartData.datasets) {
      if (chartData.hidden) {
        continue
      }
      if (chartData.data.length === 0) {
        continue
      }

      tmpMax = chartData.data.reduce((a: any, b: any) => {
        return Math.max(a, b)
      })

      if (tmpMax > scaleMax) {
        scaleMax = tmpMax
      }
    }
    scaleMax = parseInt(scaleMax.toString())
    this.temperatureDifferenceChartOptions.layout.padding.left = this.getPaddingLeftFromScaleY(scaleMax.toString().length)
  }

  private getPaddingLeftFromScaleY (digit: any, key = '') {
    if (digit === 4) {
      return 12
    }
    if (digit === 3) {
      return 20
    }
    if (digit === 2) {
      // 気温グラフは最低値が-20で2.5文字のため調整
      if (key === 'temperature') {
        return 22
      } else {
        return 28
      }
    }
  }

  /* 実績グラフのデータを抽出 */
  private createdActualResultsData (key: string) {
    let actualResultsData: any = JSON.parse(Session.getGraphData()!)
    const data: any[] = []

    // データがない場合は空を返す
    if (actualResultsData === null) {
      return []
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

      if (actualResultsData[day] !== undefined) {
        data.push(actualResultsData[day][key])
      } else {
        data.push(null)
      }
    }

    return data
  }

  private judgePointRadius (data: any[]) {
    let countNotNull: number = 0
    for (let i in data) {
      if (data[i] !== null) {
        countNotNull++
      }
    }

    // null以外に値が1件ならポイントを表示、それ以外はポイントを表示しない
    if (countNotNull === 1) {
      return 3
    } else {
      return 0
    }
  }

  /* canonの実績グラフのデータを抽出 */
  private createdCanonActualResultsData (dataName: string, key: string) {
    let allGraphData: any = JSON.parse(Session.getAllGraphData()!)
    let actualResultsData: any
    const data: any[] = []

    // データがない場合は空を返す
    if (allGraphData === undefined || allGraphData === null) {
      return []
    } else {
      actualResultsData = allGraphData[dataName]
    }

    // データがない場合は空を返す
    if (actualResultsData === undefined || actualResultsData === null) {
      return []
    }

    for (var j in this.label) {
      let date = new Date(this.label[j]).getTime()
      const dateData = actualResultsData.filter((data: any) => new Date(this.createDisplayStringDate(data.record_date) + 'T00:00:00').getTime() === date)

      if (dateData.length === 0) {
        data.push(null)
      } else {
        data.push(dateData[0][key])
      }
    }

    return data
  }

  /* canonの実績グラフのデータを抽出 */
  private createCanonComparisonData (dataName: string, key: string) {
    let allComparisonData = JSON.parse(Session.getAllComparisonData()!)
    let comparisonData: any
    const data: any[] = [null, null, null, null, null, null, null, null, null]

    // canonが非表示、またはデータがない場合は空を返す
    if (!this.showCanonData || allComparisonData === undefined || allComparisonData === null) {
      return []
    } else {
      comparisonData = allComparisonData[dataName]
    }

    // データがない場合は空を返す
    if (comparisonData === undefined || comparisonData === null) {
      return []
    }

    for (var j in this.label) {
      const dateData = comparisonData.filter((data: any) => data.elapsed_days === parseInt(j))

      if (dateData.length === 0) {
        data.push(null)
      } else {
        data.push(dateData[0][key])
      }
    }

    return data
  }

  private createDisplayStringDate (e: any) {
    const i = e.toString()
    const year = i.slice(0, 4)
    let month = i.slice(4, 6)
    const date = i.slice(6, 8)
    return year + '-' + month + '-' + date
  }

  /* 目標グラフのデータを抽出 */
  private createdGoalData (key: string) {
    let masterData: any = {}

    if (key === 'plan_water_level') {
      masterData = JSON.parse(Session.getMasterWaterLevelData()!)
    } else {
      masterData = JSON.parse(Session.getMasterData()!)
    }
    const goalArray: any[] = []
    const isDviGraph: boolean = JSON.parse(Session.getIsDviGraph()!)

    // DVIグラフボタン表示切替
    if (masterData !== null && isDviGraph !== null && isDviGraph) {
      this.showDviModalBtn = true
    } else {
      this.showDviModalBtn = false
    }

    // 目標データがない場合は空を返す
    if (masterData === null) {
      return []
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

      if (masterData[day] !== undefined) {
        goalArray.push(masterData[day][key])
      } else {
        goalArray.push(null)
      }
    }

    /*
     * 播種日のデータがnullの場合は0を挿入
     * (ラベルデータの先頭10個は空データなので[9]を指定/goalArray[9]=播種日のデータ)
    */
    if (goalArray[9] === null) {
      goalArray[9] = 0
    }
    return goalArray
  }

  /* 中干し設定モーダル */
  private showMidDrainageModal () {
    this.$store.commit('fieldDetailsState/setMidDrainageModalFlag', true)
  }

  /* DVIグラフ設定モーダル */
  private showDviGraphModal () {
    this.$store.commit('fieldDetailsState/setDviGraphModalFlag', true)
  }

  /* 生育ステージ一覧モーダル */
  private showStageListModal () {
    this.$emit('show-stage-list-modal', true)
  }

  private toAgri () {
    this.showConfirmModal = false
    window.open('https://agri-note.jp/b/login/mizu.html', '_blank')
  }

  private checkHidden (array: boolean[], display: boolean) {
    if (!display) {
      return false
    }

    if (array.indexOf(false) !== -1) {
      return true
    } else {
      return false
    }
  }
}
